<template>
  <div class="details-view">
    <cargo-left-right-resize
      v-show="Boolean(action)"
      ref="cargoLeftRightResize"
      :left-style="{flex:'none','max-width':'190px'}"
      :right-style="{'overflow': 'hidden'}"
      :show-left="action==='look'"
      style="min-height:100%"
    >
      <template v-show="action==='look'" slot="left">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :row-data="rowData"
          class="section"
          grid-style="min-width: 220px;width:100%;height:100%;"
          min-height="100%"
          :check-sub-record="false"
          :check-main-record="false"
          :deselect-main-record="false"
          :deselect-sub-record="false"
        />
      </template>
      <template slot="right">

        <div class="main-content">
          <div class="operations" style="margin-bottom: 5px">
            <div class="triggers">
              <cargo-button-group-slider ref="cargoButtonGroupSlider">
                <div v-show="action==='look'" :class="'btn-group-look' + (canOperateJob ? '' : ' cannot-operate-job')">
                  <el-button no="back" type="primary" class="can-operate" @click="goBack">{{ $t('common.btn.back') }}</el-button>
                  <el-button v-if="canEditByPermission" no="edit" :disabled="!(job && Number(job.jobState) === 0 && !JobUtils.isBlockJob(job))" type="success" @click="editEventFlag = true">{{ $t('common.btn.edit') }}</el-button>
                </div>
                <div v-show="action==='edit'" class="btn-group-edit" style="border-left:none;padding-left:0">
                  <el-button no="20" type="success" :disabled="context.loading" @click="triggerSaveEvent">{{ $t('common.btn.save') }}</el-button>
                  <el-button no="21" type="success" @click="cancelEdit(openMultiple?againLookAtMultiple:()=>{againShow('look')})">{{ $t('common.btn.cancel') }}</el-button>
                  <el-button no="22" type="primary" @click="saveDefaultVal">{{ $t('SeaExport.SaveTheDefaultValues') }}</el-button>
                </div>
                <div v-show="isNew" class="btn-group-new" style="border-left:none;padding-left:0">
                  <el-button no="23" type="success" :disabled="context.loading" @click="triggerSaveEvent">{{ $t('common.btn.save') }}</el-button>
                  <el-button no="24" type="success" @click="cancelEdit(openMultiple?goBackAtMultiple:goBack)">{{ $t('common.btn.cancel') }}</el-button>
                  <el-button no="25" type="primary" @click="saveDefaultVal">{{ $t('SeaExport.SaveTheDefaultValues') }}</el-button>
                </div>
              </cargo-button-group-slider>
              <div v-show="action==='look'||action==='edit'" style="white-space:nowrap;display:flex;">
                <!-- im入口 -->
                <CargoIm v-show="imCacheKey && action==='look'" ref="cargoIm" />
                <span no="SopState" style="font-size:14px;color:red">{{ commonInfo.jobState }}</span>
                <span v-if="job.payableChargeLockedStatus === 1" style="font-size:14px;color:red;padding-left:9px;">{{ $t('CargoMsg.Cargo_PayableLockedStatusTag') }}<el-tooltip effect="dark" :content="payableChargeLockedTooltip" placement="bottom" :visible-arrow="false"><i class="el-icon-warning" style="cursor:pointer;" /></el-tooltip></span>
                <el-tooltip effect="dark" :content="action==='edit' ? '' : $t('SeaExport.Tip1')" placement="right-end">
                  <el-button no="26" type="text" style="font-size:12px;padding: 7px 9px;color:unset;" @dblclick.native="onBtnListDoubleClicked()" v-html="commonInfo.jobTitle" />
                </el-tooltip>
                <span style="font-size:12px;color:red">{{ commonInfo.jobLock }}</span>
                <span v-if="commonInfo.provisionLock && commonInfo.provisionLock.etdLocked" style="font-size:14px;color:red;margin-left:10px;">计提已校准</span>
                <el-tooltip v-if="job.zyCreditWarning" effect="dark" :content="job.zyCreditWarning" placement="bottom-start" :visible-arrow="false">
                  <div class="right-tip" style="cursor:pointer;font-size:12px;color:orange;width:250px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">
                    <span>{{ job.zyCreditWarning }}</span>
                  </div>
                </el-tooltip>
              </div>
            </div>

          </div>
          <div ref="tabsContainer" :class="'tabs-container' + (canOperateJob ? '' : ' cannot-operate-job')">
            <el-tabs
              ref="tabs"
              v-model="activeTabName"
              type="card"
              :before-leave="(activeName,oldActiveName)=>{beforeLeaveTab(activeName,oldActiveName)}"
              style="width:100%"
              @tab-click="handleTabClick"
            >
              <!--进口操作-->
              <el-tab-pane
                v-if="!masterFlag"
                :key="1"
                :lazy="true"
                name="basicTab"
                :label="$t('SeaExport.ImportOperation')"
              >
                <basic-tab-UICustom
                  v-if="$store.state.uiCustom.enable"
                  ref="basicTab"
                  view-source="bookingWorkspace"
                  :is-cross-tenant-s-e-to-s-i="isCrossTenantSEToSI"
                  :context="context"
                  :action="action"
                  :cooperate-edit="cooperateEditOther"
                  :processing-promise-list="processingPromiseList"
                  :template-name="templateName"
                  :provision-lock="commonInfo.provisionLock"
                  @containerLoadTypeEvent="containerLoadTypeEvent"
                  @tabNotCheckedCallBack="tabNotCheckedCallBack"
                  @updateJob="$emit('updateJob')"
                />
                <basic-tab
                  v-else
                  ref="basicTab"
                  view-source="bookingWorkspace"
                  :is-cross-tenant-s-e-to-s-i="isCrossTenantSEToSI"
                  :context="context"
                  :action="action"
                  :cooperate-edit="cooperateEditOther"
                  :processing-promise-list="processingPromiseList"
                  :template-name="templateName"
                  :provision-lock="commonInfo.provisionLock"
                  @containerLoadTypeEvent="containerLoadTypeEvent"
                  @tabNotCheckedCallBack="tabNotCheckedCallBack"
                  @updateJob="$emit('updateJob')"
                />
              </el-tab-pane>
              <!--进口操作-->
              <el-tab-pane
                v-if="masterFlag"
                :key="2"
                :lazy="true"
                name="masterBasicTab"
                :label="$t('SeaExport.ImportOperation')"
              >
                <master-basic-tab-UICustom
                  v-if="$store.state.uiCustom.enable"
                  ref="masterBasicTab"
                  :context="context"
                  :action="action"
                  :is-sea-export="true"
                  view-source="bookingWorkspace"
                  :is-cross-tenant-s-e-to-s-i="isCrossTenantSEToSI"
                  :show-trucking="showTrucking"
                  :cooperate-edit="cooperateEditOther"
                  :template-name="templateName"
                  @addLcl="addBatchLcl"
                  @selectJob="jobUuid=>{transferTargetRow('edit', jobUuid)}"
                  @addSlavedJob="addSlavedJob"
                  @removeJobFromMaster="removeJobFromMaster"
                  @removeJob="removeJob"
                  @containerLoadTypeEvent="containerLoadTypeEvent"
                  @updateJob="$emit('updateJob')"
                  @verticalScroll="onVerticalScroll"
                />
                <master-basic-tab
                  v-else
                  ref="masterBasicTab"
                  :context="context"
                  :action="action"
                  :is-sea-export="true"
                  view-source="bookingWorkspace"
                  :is-cross-tenant-s-e-to-s-i="isCrossTenantSEToSI"
                  :show-trucking="showTrucking"
                  :cooperate-edit="cooperateEditOther"
                  :template-name="templateName"
                  @addLcl="addBatchLcl"
                  @selectJob="jobUuid=>{transferTargetRow('edit', jobUuid)}"
                  @addSlavedJob="addSlavedJob"
                  @removeJobFromMaster="removeJobFromMaster"
                  @removeJob="removeJob"
                  @containerLoadTypeEvent="containerLoadTypeEvent"
                  @updateJob="$emit('updateJob')"
                  @verticalScroll="onVerticalScroll"
                />
              </el-tab-pane>
              <el-tab-pane
                key="tabArrivalInformation"
                :lazy="true"
                name="tabArrivalInformation"
                :label="$t('SeaExport.ArrivalInformation')"
              >
                <tab-arrival-information-UICustom v-if="$store.state.uiCustom.enable" ref="tabArrivalInformation" :context="context" :action="action" :cooperate-edit="cooperateEditOther" />
                <tab-arrival-information v-else ref="tabArrivalInformation" :context="context" :action="action" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!masterFlag && paramsOfTab.usCustomsClearance"
                key="tabUsCustomsClearance"
                :lazy="true"
                name="tabUsCustomsClearance"
                :label="$t('queryJob.UsCustomsClearance')"
              >
                <tab-us-customs-clearance ref="tabUsCustomsClearance" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
              </el-tab-pane>
              <el-tab-pane
                v-if="masterFlag && paramsOfTab.usCustomsClearance"
                key="tabUsCustomsClearanceMaster"
                :lazy="true"
                name="tabUsCustomsClearanceMaster"
                :label="$t('queryJob.UsCustomsClearance')"
              >
                <tab-us-customs-clearance-master ref="tabUsCustomsClearanceMaster" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && (masterFlag || paramsOfTab.signMBL)"
                :key="6"
                :lazy="true"
                name="tabMBL"
                label="MB/L"
              >
                <tab-mbl ref="tabMBL" :is-cross-tenant-s-e-to-s-i="isCrossTenantSEToSI" :context="context" :action="action" :cooperate-edit="cooperateEditOther" view-source="SiBooking" @tabNotCheckedCallBack="tabNotCheckedCallBack" @resetTab="resetTab" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !isNew && (paramsOfTab.typeMBL !== 0 && paramsOfTab.typeMBL !== 1)"
                :key="7"
                :lazy="true"
                name="tabMBL2"
                :label="'MB/L '+(paramsOfTab.typeMBL===2? (this.$store.getters.language === 'zh'? '拆单':'Split'):'')+(paramsOfTab.typeMBL===3?(this.$store.getters.language === 'zh'? '并单':'Merge'):'')"
              >
                <tab-mbl2 ref="tabMBL2" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && paramsOfTab.signHBL && !masterFlag && !paramsOfTab.mblOnly"
                :key="8"
                :lazy="true"
                name="tabHBL"
                label="HB/L"
              >
                <tab-hbl ref="tabHBL" :is-cross-tenant-s-e-to-s-i="isCrossTenantSEToSI" :context="context" :action="action" :cooperate-edit="cooperateEditOther" view-source="SiBooking" @resetTab="resetTab" @syncData="syncData" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !paramsOfTab.mblOnly && !isNew && (paramsOfTab.typeHBL !== 0 && paramsOfTab.typeHBL !== 1)"
                :key="9"
                :lazy="true"
                name="tabHBL2"
                :label="'HB/L '+(paramsOfTab.typeHBL===2?(this.$store.getters.language === 'zh'? '拆单':'Split'):'')+(paramsOfTab.typeHBL===3?(this.$store.getters.language === 'zh'? '并单':'Merge'):'')"
              >
                <tab-hbl2 ref="tabHBL2" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
              </el-tab-pane>
              <!--本地服务-->
              <el-tab-pane
                v-if="showTrucking"
                :key="15"
                :lazy="true"
                name="tabLocalService"
                :label="$t('SeaExport.LocalService')"
              >
                <tab-local-service ref="tabLocalService" :context="context" :action="action" :cooperate-edit-warehouse="cooperateEditWarehouse" :cooperate-edit-trucking="cooperateEditTrucking" />
              </el-tab-pane>
              <!-- 保险 -->
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && paramsOfTab.insure"
                :lazy="true"
                name="tabInsure"
                :label="$t('SeaExport.InsureInfo')"
              >
                <tab-insure ref="tabInsure" :context="context" :action="action" />
              </el-tab-pane>
              <!-- 货物明细-->
              <el-tab-pane
                :key="19"
                :lazy="true"
                name="tabTradeDetail"
                :label="$t('SeaExport.TradeDetail')"
              >
                <tab-trade-detail ref="tabTradeDetail" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
              </el-tab-pane>
              <!--贸易-->
              <el-tab-pane
                v-if="paramsOfTab.itmService"
                :key="20"
                :lazy="true"
                name="tabTradeCommission"
                :label="$t('SeaExport.TradeCommission')"
              >
                <tab-trade-commission ref="tabTradeCommission" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
              </el-tab-pane>
              <!--装箱信息-->
              <el-tab-pane
                v-if="!masterFlag"
                :key="12"
                :lazy="true"
                name="tabContainer"
                :label="$t('SeaExport.ContainerInfo')"
              >
                <tab-container ref="tabContainer" :context="context" :action="action" :cooperate-edit="cooperateEditOther" view-source="bookingWorkspace" />
              </el-tab-pane>
              <el-tab-pane
                v-if="masterFlag && !isNew"
                :key="13"
                :lazy="true"
                name="tabLclContainer"
                :label="$t('SeaExport.ContainerInfo')"
              >
                <tab-lcl-container
                  ref="tabLclContainer"
                  :context="context"
                  :action="action"
                  :cooperate-edit="cooperateEditOther"
                  :location="location"
                  @addSlavedJob="addSlavedJob"
                  @removeJobFromMaster="removeJobFromMaster"
                  @split="splitHandle"
                />
              </el-tab-pane>
              <!-- 费用-->
              <el-tab-pane
                v-if="privilege.charge.chargeView"
                :key="21"
                :lazy="true"
                name="tabCharges"
                :label="$t('SeaExport.Charge')"
              >
                <tab-charges ref="tabCharges" :context="context" :action="action" :is-cross-tenant-se-to-si="isCrossTenantSEToSI" :location="location" view-source="SiBooking" :provision-lock="commonInfo.provisionLock" @printDataCallBack="tabChargesPrintDataCallBack" />
              </el-tab-pane>
              <!-- 国内账单-->
              <el-tab-pane
                v-if="!isNew && privilege.chargeConfirm.chargeConfirmView"
                :key="22"
                :lazy="true"
                name="tabInternalBill"
                :label="$t('SeaExport.InternalBillInfo')"
              >
                <tab-internal-bill ref="tabInternalBill" :context="context" :action="action" :location="location" />
              </el-tab-pane>
              <!-- 国外账单-->
              <el-tab-pane
                v-if="!isNew && privilege.billTab.billTabView"
                :key="23"
                :lazy="true"
                name="tabOverseaBill"
                :label="$t('SeaExport.OverseaBillInfo')"
              >
                <tab-oversea-bill ref="tabOverseaBill" :context="context" :action="action" :location="location" view-source="SiBooking" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!isNew"
                :key="24"
                :lazy="true"
                name="tabAdvanceCharge"
                :label="$t('SeaExport.AdvanceChargeInfo')"
              >
                <tab-advance-charge ref="tabAdvanceCharge" :context="context" :action="action" :location="location" />
              </el-tab-pane>
              <!-- 报关-->
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && paramsOfTab.customs"
                :key="18"
                :lazy="true"
                name="tabCustomsInfo"
                :label="$t('SeaExport.CustomsDeclaration')"
              >
                <tab-customs-info ref="tabCustomsInfo" :context="context" :action="action" :cooperate-edit="cooperateEditCustoms" />
              </el-tab-pane>
              <!-- 进口舱单-->
              <el-tab-pane
                v-if="paramsOfTab.importManifest"
                :key="18.5"
                :lazy="true"
                name="tabImportManifest"
                :label="$t('SeaImport.ImportManifest')"
              >
                <tab-import-manifest ref="tabImportManifest" :context="context" :action="action" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <!--单证流转-->
              <el-tab-pane
                v-if="!masterFlag && !isNew"
                :key="25"
                :lazy="true"
                name="tabFile"
                :label="$t('SeaExport.DocumentCirculation')"
              >
                <tab-file ref="tabFile" :context="context" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <!-- 特殊货物信息 -->
              <el-tab-pane
                v-if="!(isLclMaster && isNew) && !masterFlag && paramsOfTab.cargoType && paramsOfTab.cargoType !== 'GC'"
                :key="26"
                :lazy="true"
                name="tabSpecialGoods"
                :label="$t('SpecialGoods.label')"
              >
                <tab-special-goods ref="tabSpecialGoods" :context="context" :action="action" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <!--  业务状态-->
              <el-tab-pane
                v-if="!isNew && privilege.seBooking.portalState"
                :key="27"
                :lazy="true"
                name="tabSopState"
                :label="$t('SeaExport.BusinessStatus')"
              >
                <tab-sop-state ref="tabSopState" :context="context" :action="action" :is-cross-tenant-se-to-si="isCrossTenantSEToSI" :cooperate-edit="cooperateEditOther" :sop-template-config="sopTemplateConfig" />
              </el-tab-pane>

              <!--文件历史-->
              <el-tab-pane
                v-if="!isNew"
                :key="28"
                :lazy="true"
                name="tabFileHistory"
                :label="$t('SeaExport.FileHistory')"
              >
                <tab-file-history ref="tabFileHistory" :context="context" :cooperate-edit="cooperateEditOther" :can-operate-job="canOperateJob" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </template>
    </cargo-left-right-resize>
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      ref="templateSelectorDialog"
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!-- 多条业务 配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      :lob="lob"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
    />
    <!-- 单条业务 配置规则验证弹窗-->
    <checking-window
      v-if="checkingWindow.visible"
      :visible.sync="checkingWindow.visible"
      :lob="lob"
      :job="job"
      :check-node="checkingWindow.checkNode"
      :call-back="checkingWindow.callBack"
      :call-back2="checkingWindow.callBack2"
    />
    <!-- 预估利润率验证弹窗-->
    <estimate-validation-dialog
      ref="estimateValidationDialog"
      :visible.sync="estimateValidationDialog.visible"
      :job="estimateValidationDialog.job"
      :estimate-profit-rate="estimateValidationDialog.estimateProfitRate"
      :tatol-profit="estimateValidationDialog.tatolProfit"
      @callback="estimateValidationDialog.callback"
    />
    <!-- 退关弹窗 -->
    <el-dialog
      v-if="shutOutDialog.visible"
      v-el-drag-dialog
      no="27"
      :visible.sync="shutOutDialog.visible"
      :itle="$t('Message.Warning')"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="display: flex;flex-direction: column;padding-left:30px">
        <span style="line-height: 40px;">{{ $t('Message.PleaseConfirmTheShutOut') }}</span>
        <span style="line-height: 18px;">{{ shutOutDialog.shutOutTip1 }}</span>
        <span style="line-height: 18px;">{{ shutOutDialog.shutOutTip2 }}</span>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button no="28" type="primary" @click="hasChargeShutoutHandler()">{{ $t('Message.HasChargeToShutOut') }}</el-button>
        <el-button
          no="29"
          :style="{ display: shutOutDialog.shutOutButtonShow2 }"
          type="primary"
          @click="noHasChargeShutoutHandler()"
        >{{ $t('Message.NoChargeToShutOut') }}</el-button>
        <el-button no="30" @click="shutOutDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 数据推送变更记录弹窗 -->
    <el-dialog
      v-if="dataPushDialog.visible"
      v-el-drag-dialog
      no="31"
      :visible.sync="dataPushDialog.visible"
      :title="$t('SeaExport.DataPushChangeLog')"
      width="580px"
      :close-on-click-modal="false"
      class="app-main-inner"
      @close="dataPushDialog.visible=false"
    >
      <div
        class="app-main-inner-row"
        style="padding: 0;display: flex;flex-direction: column"
        :style="{width:'100%',height:'400px',overflow:'auto'}"
      >
        <div v-for="(title,index) in dataPushDialog.titles" :key="index">
          <div style="background:#EBECF5">
            <b>{{ title }}</b>
          </div>
          <div v-for="(item,index) in dataPushDialog.dataMap.get(title)" :key="index">
            <div>{{ item }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 业务状态变更记录弹窗 -->
    <business-status-log-dialog
      v-if="businessStatusDialog.visible"
      :visible.sync="businessStatusDialog.visible"
      :job-uuid="job.uuid || ''"
    />
    <!-- EDI状态变更记录弹窗 -->
    <edi-status-log-dialog v-if="ediStatusLogDialog.visible" :visible.sync="ediStatusLogDialog.visible" :job-uuid="job.uuid || ''" />
    <!-- 订舱回执操作日志弹窗 -->
    <booking-space-log-dialog
      v-if="bookingSpaceLogDialog.visible"
      :visible.sync="bookingSpaceLogDialog.visible"
      :job-uuid="job.uuid || ''"
    />
    <!-- SOP操作状态弹窗 :visible.sync="sopStateDialog.visible"-->
    <sop-state-dialog :hide-window="isEditing" :visible.sync="sopStateDialog.visible" :is-need-refresh.sync:="sopStateDialog.isNeedRefresh" :default-is-expand="sopStateDialog.defaultIsExpand" :job="job" :is-need-expand.sync="sopStateDialog.isNeedExpand" @handleClose="sopStateDialogClose" />
    <!-- 发送分公司/tenant内部委托 -->
    <template v-if="sendBranchWindow.visible">
      <el-dialog
        v-if="sendBranchSelectObject === 2"
        v-el-drag-dialog
        no="32"
        :visible.sync="sendBranchWindow.visible"
        :title="$t('SeaExport.ConsignationSI')"
        width="550px"
        :close-on-click-modal="false"
      >
        <el-form label-width="40px" label-position="left">
          <el-form-item label-width="0">
            <span style="color: #000000;font-size: 14px;">{{ $t('queryJob.EntrustedRecipient') }}</span>
          </el-form-item>
          <el-form-item v-for="(item, index) in sendBranchWindow.items" :key="index" :label="item.selectObject === 0 ? $t('Payment.customerService') : $t('FileHistory.operation')">
            <cargo-user-select
              :method-params="{officeId: sendBranchWindow.office.officeId, category:'role', shape: item.selectObject === 0 ? 'csr' : 'op'}"
              style="width: 200px"
              @change="p=>{item.userId=p.value;userId_changeHandler(item)}"
            />
          </el-form-item>
        </el-form>
        <el-form label-width="40px" :inline="true" label-position="left">
          <el-form-item label=" ">
            <div style="width: 200px;color: #000000;font-size: 14px;text-align: center;">{{ $store.getters.currentOffice.chineseName }}</div>
          </el-form-item>
          <el-form-item label=" ">
            <div style="width: 200px;color: #000000;font-size: 14px;text-align: center;">{{ sendBranchWindow.title }}</div>
          </el-form-item>
          <el-form-item label=" ">
            <el-select value="consignee" disabled style="width: 200px">
              <el-option :label="$t('Message.Consignee')" value="consignee" />
            </el-select>
          </el-form-item>
          <el-form-item label-width="44px">
            <span slot="label" style="color: rgb(153, 153, 153);">———</span>
            <el-select v-model="sendBranchWindow.consigneeTarget" style="width: 200px" @change="onConsigneeTargetChange">
              <el-option :label="$t('Message.Consignee')" value="consignee" />
              <el-option :label="$t('SeaExport.ConsignationCompany')" value="customer" />
            </el-select>
          </el-form-item>
          <el-form-item label=" ">
            <el-select value="consigneeDetail" disabled style="width: 200px">
              <el-option :label="$t('SeaExport.ConsigneeDetail')" value="consigneeDetail" />
            </el-select>
          </el-form-item>
          <el-form-item label-width="44px">
            <span slot="label" style="color: rgb(153, 153, 153);">———</span>
            <el-select v-model="sendBranchWindow.consigneeDetailTarget" style="width: 200px" @change="onConsigneeDetailTargetChange">
              <el-option :label="$t('SeaExport.ConsigneeDetail')" value="consigneeDetail" />
              <el-option :label="$t('SeaExport.ShipperDetail')" value="shipperDetail" />
            </el-select>
          </el-form-item>
        </el-form>
        <div style="margin-top: 20px;">{{ $t('queryJob.NoteConsigneeCustomerExportImport') }}</div>
        <div slot="footer" style="display: flex;justify-content: space-between;">
          <el-checkbox v-model="sendBranchWindow.checkConsigneeDefault" style="color: #000000" @change="onCheckConsigneeDefaultChange">{{ $t('queryJob.SetAsDefaultExportInfo') }}</el-checkbox>
          <div>
            <el-button no="33" type="primary" @click="enterSendHandler">{{ $t('common.btn.confirm') }}</el-button>
            <el-button no="34" @click="sendBranchWindow.visible=false">{{ $t('common.btn.cancel') }}</el-button>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        v-else
        v-el-drag-dialog
        no="32"
        :visible.sync="sendBranchWindow.visible"
        :title="sendBranchWindow.title"
        width="360px"
        :close-on-click-modal="false"
      >
        <el-form label-width="85px" label-position="left">
          <el-form-item v-for="(item, index) in sendBranchWindow.items" :key="index" :label="item.selectObject === 0 ? $t('Payment.customerService') : $t('FileHistory.operation')">
            <cargo-user-select
              :method-params="{officeId: sendBranchWindow.office.officeId, category:'role', shape: item.selectObject === 0 ? 'csr' : 'op'}"
              @change="p=>{item.userId=p.value;userId_changeHandler(item)}"
            />
          </el-form-item>
          <el-form-item v-if="showdCheckSalesMapping" :label="$t('queryJob.SalesMapping')">
            <el-checkbox v-model="sendBranchWindow.checkSalesMapping" no="checkSalesMapping">{{ $t('queryJob.SalesCargoSalesMap') }}</el-checkbox>
          </el-form-item>
        </el-form>
        <div slot="footer" style="margin: 0 auto;width: fit-content;">
          <el-button no="33" type="primary" @click="enterSendHandler">{{ $t('common.btn.confirm') }}</el-button>
          <el-button no="34" @click="sendBranchWindow.visible=false">{{ $t('common.btn.cancel') }}</el-button>
        </div>
      </el-dialog>
    </template>
    <!--关联业务信息-->
    <trust-from-window
      v-if="trustFromWindow.visible"
      ref="trustFromWindow"
      :visible.sync="trustFromWindow.visible"
      :trust-job="trustFromWindow.trustJob"
      :job="job"
      :is-cross-tenant-se-to-si="isCrossTenantSEToSI"
      :context="context"
      :can-operate-job="canOperateJob"
      @refresh="refresh"
    />
    <cross-tenant-change-history-dialog v-if="crossTenantDialog.visible" :visible.sync="crossTenantDialog.visible" :data="crossTenantDialog.data" :has-un-read="crossTenantDialog.readState" :job-uuid="job.uuid" :lob="job.lob" />
    <!-- 验证规则-保存业务节点弹窗 -->
    <checking-save-job-window
      v-if="checkingSaveJobWindow.visible"
      :visible.sync="checkingSaveJobWindow.visible"
      lob="SI"
      :row-data="checkingSaveJobWindow.rowData"
      :check-node="checkingSaveJobWindow.checkNode"
      :call-back="checkingSaveJobWindow.callBack"
    />
    <!--选择协作分公司-->
    <cooperation-branch-list
      v-if="cooperationBranchListDialog.visible"
      :visible.sync="cooperationBranchListDialog.visible"
      :job-uuid="cooperationBranchListDialog.jobUuid"
      :job="cooperationBranchListDialog.job"
      :order-center-branch="cooperationBranchListDialog.orderCenterBranch"
      @refresh="(cooperatebranch)=>{updateJobCooperate(cooperatebranch);this.$refs.tabCharges.refreshCooperatebranch(cooperatebranch)}"
      @cancel="()=>cooperationBranchListDialog.visible=false"
    />
    <!-- 业务申请审批流 -->
    <job-apply-dialog
      v-if="jobApplyDialog.visible"
      :visible.sync="jobApplyDialog.visible"
      :title="$t('CargoMsg.Cargo_SubmitJobChargeForApproval')"
      type="apply"
      :doc-id="job.uuid"
      :document-config-id="documentConfigId"
      @close="jobApplyDialog.visible=false"
      @closeAndRefresh="applyCloseAndRefresh"
    />
    <!-- api接口选择弹窗 -->
    <api-popup
      :visible.sync="apiPopup.visible"
      :title="apiPopup.title"
      :interface-type="apiPopup.interfaceType"
      :interface-array="apiPopup.interfaceArray"
      @selectedApi="selectedApiCallback"
    />
    <error-log-dialog
      :visible.sync="errorLogDialog.visible"
      :error-log="errorLogDialog.errorLog"
    />
    <job-return-review-dialog
      v-show="returnReviewDialog.visible"
      :visible.sync="returnReviewDialog.visible"
      lob="SI"
      :selected-jobs="returnReviewDialog.selectedJobs"
      srouce="detail"
      @confirm="refresh"
    />
    <!-- 变更日志记录 弹窗 -->
    <data-update-log-dialog :hide-window="isEditing" :visible.sync="dataUpdateLogDialog.visible" :is-need-refresh.sync:="dataUpdateLogDialog.isNeedRefresh" :default-is-expand="dataUpdateLogDialog.defaultIsExpand" :job="job" :is-need-expand.sync="dataUpdateLogDialog.isNeedExpand" @handleClose="dataUpdateLogDialogClose" />
  </div>
</template>

<script>
import hblIcon from '@/assets/h_resize.png'
import mblIcon from '@/assets/m_resize.png'
import { BookingWorkspaceContext } from '@/views/cargo/v0/SeaImport/components/SiBooking/bookingWorkspaceContext'
import { BookingWorkspacePM } from '@/views/cargo/v0/SeaImport/components/SiBooking/bookingWorkspacePM'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import URL from '@/api/urlTranslator'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import businessStatusLogDialog from '@/views/cargo/v0/Clearing/components/financeManage/businessStatusLogDialog'
import ediStatusLogDialog from '@/components/Cargo/Job/ediStatusLogDialog'
import bookingSpaceLogDialog from '@/components/Cargo/Job/bookingSpaceLogDialog'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'
import CheckingWindow from '@/components/Cargo/Job/CheckingManager/CheckingWindow'
import EstimateValidationDialog from '@/components/Cargo/Job/estimateValidationDialog'
import ChatDialog from '@/components/Cargo/Common/CargoIm/chatDialog'
import CargoIm from '@/components/Cargo/Common/CargoIm'
import { TabError } from '@/utils/class/TabError'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache, getCacheListByKey, operateBranchIsOptional } from '@/utils/basicDataCache'
import { getUserDefaultDepartment } from '@/api/user'
import { getOfficeByUuid } from '@/api/office'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import ColumnUtils from '@/utils/ColumnUtils'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { Company } from '@/class/model/mdm/Company'
import { Office } from '@/class/model/sys/Office'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { EntityDefaultValueUtil } from '@/class/cargo/model/utils/EntityDefaultValueUtil'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import { PrintUtils } from '@/utils/PrintUtils'
import { StimulSoftUtil } from '@/class/cargo/model/utils/StimulSoftUtil'
import { PrintTemplateManager } from '@/class/cargo/model/utils/PrintTemplateManager'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import DateUtils from '@/utils/dateUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { ensureExecuteSuccess, deepCopy, catchErrorTip, sleep, MarkManage, stringToNumArray } from '@/utils/commonUtil'
import { getDocumentType } from '@/api/documentType'
import { checkJobProvisionFlag, normalizeProvisionLock } from '@/api/provision/provisionData'
import { cache } from '@/utils/cacheManager'
import * as EdiType from '@/class/cargo/model/parameters/EdiType'
import errorLogDialog from '@/views/cargo/v0/SeaExport/components/edi/errorLogDialog'
import {
  canBatchShutout,
  shutOut,
  getChargeIsInvoice,
  commit,
  saveJobInfo,
  calculateProfit,
  printProfit,
  prePrintProfit,
  feedbackBookingData,
  checkingConsignationJob,
  crossTenantJob,
  isContractExpiredForbidCreateJob,
  getTrustFromJob
} from '@/api/seaExport/seaExportJob'
import { queryCompany, mainTainCurrentTenantCompanies, getCompanyByTenantIdAndBranchIdAndScac } from '@/api/company'
import { updateChangeState } from '@/api/clearing/financeManage'
import { queryLatestState, isRejectedBySendJobNo, isCrossed } from '@/api/booking/crossTenantHistory'
import { isHavePorts } from '@/api/seaport'
import { isHavePacking } from '@/api/basicData/packing'
import { queryTemplateByNameAndType } from '@/api/sysManage/baseConfig/template'
import { sortByMultiField } from '@/utils'
import sopStateDialog from '@/components/Cargo/Job/sopStateDialog'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'

import basicTab from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/basicTab'
import basicTabUICustom from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/basicTabUICustom'
import tabMbl from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabMBL'
import tabMbl2 from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabMBL2'
import tabHbl from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabHBL'
import tabHbl2 from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabHBL2'
import tabContainer from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabContainer'
import tabLclContainer from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabLclContainer'
import tabWarehouse from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabWarehouse'
import tabTrucking from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabTruckingSI'
import tabWarehouseIn from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabWarehouseIn'
import tabCustomsInfo from '@/components/Cargo/Job/booking/tabs/tabCustomsInfo'
import tabImportManifest from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabImportManifest'
import tabTradeDetail from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabTradeDetail'
import tabTradeCommission from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabTradeCommission'
import tabCharges from '@/components/Cargo/Job/booking/tabs/tabCharges'
import tabInternalBill from '@/components/Cargo/Job/booking/tabs/tabInternalBill'
import tabOverseaBill from '@/components/Cargo/Job/booking/tabs/tabOverseaBill'
import tabAdvanceCharge from '@/components/Cargo/Job/booking/tabs/tabAdvanceCharge'
import tabFile from '@/components/Cargo/Job/booking/tabs/tabFile'
import tabSopState from '@/components/Cargo/Job/booking/tabs/tabSopState'
import tabFileHistory from '@/components/Cargo/Job/booking/tabs/tabFileHistory'
import tabLocalService from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabLocalService'
import tabSpecialGoods from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabSpecialGoods'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { backReturn, queryCrossTenantSyncHistory, sendJobCBMS, sendJobSiRui } from '@/api/booking/job'
import {
  syncLclSlaveJobInfo,
  saveSeaBookingSpace,
  saveCopyJob,
  syncTrustFromJob,
  saveCloneJobFunc,
  getRelatedJobFunc
} from '@/api/SeaImport/seaImportJob'
import { SeaExportUtils } from '@/class/cargo/model/utils/SeaExportUtils'
import masterBasicTab from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/masterBasicTab'
import masterBasicTabUICustom from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/masterBasicTabUICustom'
import StrUtils from '@/utils/StrUtils'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import DropUploader from '@/components/Cargo/Common/DropUploader'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import lodash from 'lodash'
import * as ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { sendHecMessageByJob, backHecMessageByJob } from '@/api/clearing/charge'
import CrossTenantChangeHistoryDialog from '@/components/Cargo/Job/crossTenantDialogChangeHistory'
import TrustFromWindow from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/siTrustFromWindow'
import checkingSaveJobWindow from '@/components/Cargo/Job/CheckingManager/CheckingSaveJobWindow'
import tabUsCustomsClearance from '@/components/Cargo/Job/booking/tabs/tabUsCustomsClearance'
import tabUsCustomsClearanceMaster from '@/components/Cargo/Job/booking/tabs/tabUsCustomsClearanceMaster'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { SopUtil } from '@/class/cargo/model/utils/SopUtil'
import cooperationBranchList from '@/components/Cargo/Job/cooperationBranchList'
import { updateState } from '@/api/booking/jobCooperate'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { getImGroup } from '@/api/cargoIm'
import JobApplyDialog from '@/components/Cargo/Common/Wrokflow/jobApplyDialog'
import { Job_CHARGE } from '@/class/cargo/model/parameters/WorkflowConstants'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import tabArrivalInformation from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabArrivalInformation'
import tabArrivalInformationUICustom from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabArrivalInformationUICustom'
import TabInsure from '@/components/Cargo/Job/booking/tabs/tabInsure'
import { LOG_SI_SEA_BOOKING } from '@/class/cargo/model/parameters/SystemConstants'
import DataUpdateLogDialog from '@/components/Cargo/Job/dataUpdateLogDialog'
import BookingWorkspaceMixin from '@/mixin/BookingWorkspaceMixin'
import ApiPopup from '@/views/cargo/v0/SeaExport/components/edi/apiPopup.vue'
import * as ediApi from '@/api/seaExport/edi'
import jobReturnReviewDialog from '@/components/Cargo/Job/jobReturnReviewDialog.vue'
import { getSopTemplateConfig } from '@/api/sysManage/baseConfig/businessManage'
import { createDetailTabComponent } from './destinationDetailTabMixin'

const SiDetailBasicTab = createDetailTabComponent(basicTab)
const SiDetailBasicTabUICustom = createDetailTabComponent(basicTabUICustom)

export default {
  name: 'SiDetailWorkspace',
  components: {
    jobReturnReviewDialog,
    ApiPopup,
    TrustFromWindow,
    CrossTenantChangeHistoryDialog,
    CargoButtonGroupSlider,
    DropUploader,
    masterBasicTab,
    masterBasicTabUICustom,
    basicTab: SiDetailBasicTab,
    basicTabUICustom: SiDetailBasicTabUICustom,
    cargoAdvanceSelect, cargoUserSelect, cargoLeftRightResize, cargoTemplateSelectorDialog, businessStatusLogDialog, ediStatusLogDialog, bookingSpaceLogDialog,
    tabMbl, tabMbl2, tabHbl, tabHbl2,
    tabContainer, tabLclContainer, tabWarehouse, tabTrucking, tabWarehouseIn, tabCustomsInfo, tabImportManifest, tabTradeDetail,
    tabTradeCommission, tabCharges, tabInternalBill, tabOverseaBill, tabAdvanceCharge, tabFile, tabSopState, tabFileHistory, tabArrivalInformation,
    tabArrivalInformationUICustom,
    CheckingWindow, EstimateValidationDialog, BatchCheckingWindow, sopStateDialog, tabLocalService, tabSpecialGoods, checkingSaveJobWindow, tabUsCustomsClearance,
    tabUsCustomsClearanceMaster, cooperationBranchList, ChatDialog, CargoIm, JobApplyDialog, TabInsure, DataUpdateLogDialog, errorLogDialog
  },
  mixins: [BookingWorkspaceMixin],
  props: {
    parentContext: {
      type: Object,
      required: true
    },
    openMultiple: {
      type: Boolean,
      default: false
    },
    view: { type: String, default: '' }
  },
  data() {
    const leftGridColumnType = LocalStorageUtilsNew.getConfiguration('SI_LEFT_GRID_TYPE', 'string') || 'jobNo'
    return {
      JobUtils,
      imCacheKey: '',
      leftGridColumnType,
      optName: '', // 操作名称
      visible: false,
      URL,
      selectTypeNames: TYPE_NAMES,
      context: new BookingWorkspaceContext(this.parentContext),
      pm: new BookingWorkspacePM(this),
      SystemConstants,
      copyJobNum: 0,
      privilege: {
        seBooking: {
          portalState: this.$checkPermission(['tab_SIBOOKING_portalState'])
        },
        salesQueryModule: {
          vesselEqTab: this.$checkPermission(['tab_SalesQueryModule_VesselEqTab'])
        },
        charge: {
          chargeView: this.$checkPermission(['tab_Charge_chargeView']),
          advanceCharge: this.$checkPermission(['tab_Charge_advanceCharge'])
        },
        chargeConfirm: {
          chargeConfirmView: this.$checkPermission(['tab_ChargeConfirm_chargeConfirmView'])
        },
        billTab: {
          billTabView: this.$checkPermission(['tab_billTab_billTabView'])
        },
        fileHistory: {
          fileHistoryView: this.$checkPermission(['tab_FileHistory_fileHistoryView'])
        }
      },
      btnInfo: {
        label: {
          shutOutLabel: this.$t('SeaExport.ShutOut'),
          btnEntrustment: this.$t('SeaExport.Consignation') // 内部委托按钮
        },
        visible: {
          sendBackBookingButton: false, // 发送订舱数据
          printFclProfit: false, // 整箱利润打印
          printLclProfit: false, // 拼箱利润打印
          cancelReturn: false, // 退回操作
          printReturn: false, // 撤回
          printReturnOperate: false, // 退回
          btnSubmit: false, // 提交
          btnManagerSubmit: false, // 主管提交
          btnPreSubmit: false, // 预提交
          btnManagerAuditSubmit: false // 审核
        },
        enabled: {
          printFclProfit: false, // 整箱利润打印
          printLclProfit: false // 拼箱利润打印
        },
        privilege: {
          btnEntrustment: null, // 委托按钮是否禁用
          btnShutout: false, // 退关按钮是否可用
          consignationEnable: false, // 内部委托按钮是否可用
          consignationCrossEnable: false, // 跨分公司委托是否可用
          crossMoreSign: false,
          button_SIBooking_cancelShutout: this.$checkPermission(['button_SIBooking_cancelShutout']),
          button_SIBooking_Shutout: this.$checkPermission(['button_SIBooking_Shutout']),
          button_JobBooking_Submit: this.$checkPermission(['button_JobBooking_Submit']),
          button_JobBooking_PreSubmit: this.$checkPermission(['button_JobBooking_PreSubmit']),
          button_JobBooking_ManagerSubmit: this.$checkPermission(['button_JobBooking_ManagerSubmit']),
          button_JobBooking_ManagerAuditSubmit: this.$checkPermission(['button_JobBooking_ManagerAuditSubmit']),
          button_JobBooking_PrintProfit: this.$checkPermission(['button_JobBooking_PrintProfit']),
          button_SEBooking_cancelProfit: this.$checkPermission(['button_SEBooking_cancelProfit']),
          button_JobBooking_Retract: this.$checkPermission(['button_JobBooking_Retract']),
          button_JobBooking_ReturnToOperater: this.$checkPermission(['button_JobBooking_ReturnToOperater'])
        }
      },
      commonInfo: {
        operateNameCode: -1, // 操作code
        jobState: '',
        jobTitle: '',
        invoiceMode: '',
        jobLock: '',
        provisionPublished: false, // 计提已发布状态
        provisionLock: { etdLocked: false, feeLocked: false },
        isPreCommit: false, // 预提交
        isPrintCommit: false, // 打印利润分析表是否提交业务
        allSubmitFcl: false, // 主票提交时是否提交全部拼票业务
        reqInputCharge: false, // 是否必录费用
        isBookingFeeMandatoryAppliedGlobally: false, // 订舱费用必填是否全模块应用
        checkEstimate: false, // 预估是否验证过
        isCopySellingCharge: false, // 复制应付费用
        needConfirmDuplicateWarehouseNo: false, // 是否要验证进仓编号重复
        synchronousShipperCodeAndConsigneeCodeAndNotifyCode: false, // 提单收发通代码是否同步至基本页签收发通代码
        isPrint: true,
        isPrintOpr: false, // 是否打印操作（由于打印和提交中最后调用的有相同的方法，因此用改参数区分开来）
        printEvent: null,
        openHecConfig: false, // 合创推送
        showMessage: true,
        showTruckingBySIMaster: false, // 是否海进主票显示门点派车信息
        toExoSystemJYD: false, // 是否JYD
        sendBranchSelectObjectOrigin: '0' // 发送分公司选项配置原始值
      },
      action: '',
      isSwitchingJob: false, // 是否正在切换job（尾程商务/海外跟单）
      editEventFlag: false, // 编辑事件标识
      saveEventFlag: false, // 保存事件标识
      backEventFlag: false, // 返回事件标识
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressContextMenu: false,
        treeData: true,
        groupDefaultExpanded: 2,
        defaultColDef: {
          resizable: true
        },
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: leftGridColumnType === 'jobNo' ? this.$t('SeaExport.BusinessNo') : 'MBL',
          colId: leftGridColumnType,
          field: leftGridColumnType,
          width: 160,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            innerRenderer: params => {
              const currentJob = params.data
              if (currentJob && currentJob.dataType && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
                const icon = Number(currentJob.dataType) === 5 ? hblIcon : mblIcon
                return `<span><img src="${icon}" height="16" width="16" style="vertical-align: sub;margin-right:2px;" />${params.value}</span>`
              }
              return `<span>${params.value}</span>`
            }
          },
          suppressMenu: true
        },
        columnDefs: [],
        context: {
          componentParent: this
        },
        getContextMenuItems: () => {
          const self = this
          const menu = [
            'copy',
            {
              name: self.$t('SeaExport.BusinessNo'),
              action: function() {
                self.leftGridColumnType = 'jobNo'
                LocalStorageUtilsNew.setConfiguration('SI_LEFT_GRID_TYPE', 'jobNo')
              }
            }, {
              name: 'MBL',
              action: function() {
                self.leftGridColumnType = 'mbl'
                LocalStorageUtilsNew.setConfiguration('SI_LEFT_GRID_TYPE', 'mbl')
              }
            }
          ]
          return menu
        },
        tabToNextCell: this.tabToNextCell,
        onCellClicked: async event => {
          const multipleJobViewMode = Number(this.config.get('MultipleJobViewMode')) || 0
          // 双击检测
          if (multipleJobViewMode === 1 || multipleJobViewMode === 2) {
            const mark = this.markManage.regenerateMark('onCellClicked')
            await sleep(500)
            if (this.markManage.readMark('onCellClicked') !== mark) {
              return
            }
          }
          this.onCellClicked(event)
        },
        onCellDoubleClicked: event => {
          const multipleJobViewMode = Number(this.config.get('MultipleJobViewMode')) || 0
          if (multipleJobViewMode === 1 || multipleJobViewMode === 2) {
            // 中断单击处理
            this.markManage.regenerateMark('onCellClicked')
            this.onCellDoubleClicked(event)
          }
        }
      },
      rowData: [],
      currentRow: {},
      paramsOfTab: {},
      pendTabSet: new Set(),
      isRefresh: false,
      activeTabName: '',
      partner: {}, // 发送分公司-合作伙伴
      relatedJobUUID: '', // 跨tenant委托，接收方的jobUuid
      template: {}, // 跨tenant委托后调用模板，上传到云存储
      templateSelectorDialog: {
        visible: false,
        ctx: new SeaImportJob(),
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      lob: 'SI',
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      checkingWindow: {
        visible: false,
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      estimateValidationDialog: {
        visible: false,
        job: { estimateAccountsReceivable: 0, estimateAccountsPayable: 0, estimateGrossProfit: 0, situation: '' },
        estimateProfitRate: 0,
        tatolProfit: 0,
        callback: () => {}
      },
      shutOutDialog: {
        visible: false,
        shutOutTip1: '',
        shutOutTip2: '',
        shutOutButtonShow2: '',
        jobKeys: '',
        hasCharge: false
      },
      submitDialog: {
        visible: false
      },
      logCommand: this.$t('CargoMsg.Cargo_LogRecord'),
      dataPushDialog: {
        visible: false,
        titles: [],
        dataMap: new Map()
      },
      businessStatusDialog: {
        visible: false
      },
      ediStatusLogDialog: {
        visible: false
      },
      bookingSpaceLogDialog: {
        visible: false
      },
      sopStateDialog: {
        visible: false,
        isNeedRefresh: false,
        job: {},
        defaultIsExpand: false,
        isNeedExpand: false
      },
      sendBranchSelectObject: 0,
      sendBranchWindow: {
        visible: false,
        office: {},
        title: this.$t('SeaExport.SelectAction'),
        items: [{
          selectObject: 0,
          userId: 0,
          departmentId: 0,
          departmentOfficeId: 0
        }],
        consigneeTarget: '',
        consigneeDetailTarget: '',
        checkConsigneeDefault: false // 将本次内容设置为默认转出口信息
      },
      trustFromWindow: {
        visible: false,
        trustJob: null // 关联业务job
      },
      saveJobNos: [], // 保存后的jobNo
      removedJobNos: [], // 被移除的jobNo
      isOtherEdit: false, // 拆分主票，复制业务，都属于新增的数据，uuid为空，但是大部分字段已经有值，不需要走初始化数据操作
      tabChargesPrintData: null, // tabCharges printData回调数据
      btnGroupLook: null,
      btnGroupEdit: null,
      markManage: new MarkManage(),
      btnGroupNew: null,
      crossTenantDialog: {
        visible: false,
        readState: false,
        data: []
      },
      isCrossTenantSEToSI: false,
      checkingSaveJobWindow: {
        visible: false,
        checkNode: 0,
        callBack: null,
        rowData: []
      },
      useOrderCenterMode: false, // 是否开启接单中心模式
      useOrderCenterBranch: false, // 是否开启接单分公司
      cooperationBranchListDialog: { // 协作分公司
        visible: false,
        jobUuid: '',
        job: null,
        orderCenterBranch: false
      },
      jobApplyDialog: {
        visible: false
      },
      documentConfigId: Job_CHARGE.code,
      dataUpdateLogDialog: {
        visible: false,
        isNeedRefresh: false,
        job: {},
        defaultIsExpand: false,
        isNeedExpand: false
      },
      bookingEDIApiOpen: false,
      apiPopup: { // api弹框
        visible: false,
        title: '',
        state: '',
        interfaceType: 1,
        interfaceArray: ''
      },
      combinedManifest: false,
      bookingBtn: false,
      // 错误日志显示弹窗
      errorLogDialog: {
        visible: false,
        errorLog: ''
      },
      returnReviewDialog: {
        visible: false,
        selectedJobs: []
      },
      processingPromiseList: [], // 正在处理中的异步操作对象列表
      sopTemplateConfig: {}, // SOP模板配置
      templateName: ''
    }
  },
  computed: {
    gridApi() {
      return this.gridOptions.api
    },
    user() {
      return this.context.user
    },
    office() {
      return this.context.office
    },
    config() {
      return this.context.config
    },
    isNew() {
      return this.action === 'add' || this.action === 'split' || this.action === 'copy'
    },
    isEditing() {
      return this.action !== 'look'
    },
    masterFlag() {
      return this.paramsOfTab.masterFlag
    },
    isLclMaster() {
      return !!this.paramsOfTab.lclMasterUuid
    },
    isVerify() {
      // 预审
      return false
    },
    job() {
      return this.currentRow
    },
    showTrucking() {
      return !this.paramsOfTab.masterFlag || (this.paramsOfTab.masterFlag && this.commonInfo.showTruckingBySIMaster)
    },
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },
    viewJobNoSet() {
      const openSet = new Set()
      for (const view of this.visitedViews) {
        if (view.path === this.$route.path && view.query && view.query.openNew && view.query.key) {
          openSet.add(view.query.key)
        }
      }
      return openSet
    },
    saveJobNosLength() {
      return this.saveJobNos.length
    },
    orderCenterBranch() { // 是否接单分公司
      return this.cooperateStatus === -1
    },
    cooperateBranchId() { // 协作分公司
      return this.$store.getters.currentOfficeId
    },
    cooperateStatus() {
      let cooperateStatus = this.paramsOfTab.cooperateStatus || -1
      if (this.paramsOfTab.cooperateCooperateStatus) {
        cooperateStatus = this.paramsOfTab.cooperateCooperateStatus
      }
      return cooperateStatus
    },
    cooperateBusinessTypeCode() {
      let cooperateBusinessTypeCode = this.paramsOfTab.cooperateBusinessTypeCode || ''
      if (!cooperateBusinessTypeCode && this.paramsOfTab.cooperateBusinessType) {
        cooperateBusinessTypeCode = this.paramsOfTab.cooperateBusinessType
      }
      return cooperateBusinessTypeCode
    },
    cooperateEditCustoms() { // 报关
      if (this.job && this.job.businessLock) {
        return false
      }
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Customs')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditTrucking() { // 陆运
      if (this.job && this.job.businessLock) {
        return false
      }
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Trucking')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditBooking() { // 订舱
      if (this.job && this.job.businessLock) {
        return false
      }
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Booking')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditWarehouse() { // 仓储
      if (this.job && this.job.businessLock) {
        return false
      }
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Warehouse')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditOther() { // 其他
      if (this.job && this.job.businessLock) {
        return false
      }
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      if (this.orderCenterBranch) return true
      return false
    },
    isCooperate() { // 是否协作业务
      if (this.useOrderCenterMode && !this.orderCenterBranch && this.paramsOfTab.cooperateUuid) {
        return true
      }
      return false
    },
    location() {
      return LOG_SI_SEA_BOOKING.code
    },
    hqDisabledOperate() {
      return this.$store.getters.currentOfficeId === 1 && this.hqViewAllDetail
    },
    canOperateJob() {
      if (this.hqViewAllDetail) {
        if (this.$store.getters.currentOfficeId === 1) {
          return false
        }
        if (this.currentRow && this.currentRow.opOffice !== this.$store.getters.currentOfficeId && this.currentRow.salesOffice !== this.$store.getters.currentOfficeId && !this.mactchCooperateBranch(this.currentRow.cooperatebranch, this.$store.getters.currentOffice)) {
          return false
        }
      }
      if (this.hierarchyViewDetail && this.currentRow) {
        return this.matchOwnerBranch(this.currentRow)
      }
      return true
    },
    canEditByPermission() {
      const menuType = this.$route.query.menuType
      const permissionCode = menuType === 'overseaTracking' ? 'button_OverseaTrackingEdit' : 'button_EndCommerceEdit'
      return this.$checkPermission([permissionCode])
    },
    showdCheckSalesMapping() {
      return this.toExoSystemJYD && Number(this.sendBranchSelectObjectOrigin) === 3
    },
    showReturnReview() { // 是否显示退回按钮
      return this.currentRow.jobState === SystemConstants.STATE_OPERATING.code && !this.currentRow.masterFlag &&
        !this.currentRow.lclMasterUuid && (this.currentRow.preverifyState === SystemConstants.VERIFYING_AUDITED.code ||
        this.currentRow.preverifyState === SystemConstants.VERIFYING_REVIEW_THROUGH.code)
    },
    trackingTemplateUuid() {
      return this.currentRow.trackingTemplateUuid
    }
  },
  watch: {
    leftGridColumnType(newVal) {
      this.gridApi.setAutoGroupColumnDef({
        headerName: newVal === 'jobNo' ? this.$t('SeaExport.BusinessNo') : 'MBL',
        colId: newVal,
        field: newVal,
        width: 160,
        cellRendererParams: {
          suppressCount: true,
          suppressDoubleClickExpand: true,
          innerRenderer: params => {
            const currentJob = params.data
            if (currentJob && currentJob.dataType && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
              const icon = Number(currentJob.dataType) === 5 ? hblIcon : mblIcon
              return `<span><img src="${icon}" height="16" width="16" style="vertical-align: sub;margin-right:2px;" />${params.value}</span>`
            }
            return `<span>${params.value}</span>`
          }
        },
        suppressMenu: true
      })
    },
    action(newVal) {
      this.$nextTick(() => {
        this.$refs.cargoButtonGroupSlider.resizeHandler()
      })
    },
    editEventFlag(newVal) {
      if (newVal) {
        this.editEventFlag = false
        return catchErrorTip(() => {
          return this.editHandler('edit')
        })
      }
    },
    saveEventFlag(newVal) {
      if (newVal) {
        this.saveEventFlag = false
        return catchErrorTip(() => {
          return this.save()
        })
      }
    },
    backEventFlag(newVal) {
      if (newVal) {
        this.backEventFlag = false
        return catchErrorTip(() => {
          return this.goBack()
        })
      }
    },
    saveJobNosLength(newVal, oldVal) {
      if (newVal > oldVal) {
        const changedRows = this.saveJobNos.slice(oldVal)
        for (const item of changedRows) {
          this.syncViewData(item)
        }
      }
    },
    '$store.getters.currentOfficeId': {
      handler() {
        if (!(this.$route.path.startsWith('/DestinationBusiness') || this.$route.name === 'SiBooking') || this.view !== 'detail') {
          return
        }
        if (this.hqViewAllList && !this.hqViewAllDetail) {
          if (this.$store.getters.currentOfficeId === 1) {
            this.$confirm(this.$t('queryJob.SwitchHQNotView'), this.$t('BusinessIntelligence.businessIntelligenceChart.warmPrompt'), {
              confirmButtonText: this.$t('queryJob.JumpListPage'),
              showCancelButton: false,
              showClose: false,
              closeOnClickModal: false,
              type: 'warning'
            }).then(() => {
              this.goBack()
            }).catch(() => {})
          }
        }
      }
    },
    trackingTemplateUuid: {
      immediate: true,
      async handler(newVal) {
        this.templateName = await SopUtil.getTemplateName(newVal)
      }
    }
  },
  async created() {
    await this.context.prepareData()
    this.loadConfigData()
    getSopTemplateConfig({ lob: 'SI' }).then(res => {
      this.sopTemplateConfig = res.data
    })
  },
  mounted() {
    this.btnGroupLook = this.$el.getElementsByClassName('btn-group-look')[0]
    this.btnGroupEdit = this.$el.getElementsByClassName('btn-group-edit')[0]
    this.btnGroupNew = this.$el.getElementsByClassName('btn-group-new')[0]
    this.sendBranchWindow.checkConsigneeDefault = LocalStorageUtilsNew.getConfiguration('SI_checkConsigneeDefault') || false
    if (this.sendBranchWindow.checkConsigneeDefault) {
      this.sendBranchWindow.consigneeTarget = LocalStorageUtilsNew.getConfiguration('SI_consigneeTargett', 'string') || 'consignee'
      this.sendBranchWindow.consigneeDetailTarget = LocalStorageUtilsNew.getConfiguration('SI_consigneeDetailTarget', 'string') || 'consigneeDetail'
    }
  },
  activated() {
    if (!this.action) {
      return
    }
    if (this.openMultiple) {
      const leftSize = LocalStorageUtilsNew.getConfiguration('SI_LEFT_SIZE')
      if (leftSize) {
        this.$refs.cargoLeftRightResize.$refs.left.style.width = leftSize
      }
      let action = ''
      if (this.$route.params.action === 'edit') {
        delete this.$route.params.action
        if (this.action === 'look') {
          action = 'edit'
        }
      }
      if (this.$route.params.isDirty) {
        delete this.$route.params.isDirty
        if (this.action === 'look') {
          this.reset([this.currentRow])
          this.againShow(action || 'look')
        } else {
          this.$message.warning(this.$t('queryJob.DataChangedToReopen'))
        }
        action = ''
      }
      if (action) {
        this.againShow(action)
      }
    } else {
      let action = ''
      if (this.viewJobNoSet.has(this.currentRow.jobNo)) {
        const rows = this.rowData.filter(p => !this.viewJobNoSet.has(p.jobNo))
        if (rows.length > 0) {
          this.currentRow = rows[0]
          action = 'look'
        } else {
          this.goBack()
          return
        }
      }
      const changedJobNos = this.$route.params.changedJobNos
      if (changedJobNos) {
        delete this.$route.params.changedJobNos
        // 重置关联数据
        for (const item of this.rowData) {
          if (changedJobNos.includes(item.jobNo)) {
            if (item.jobNo === this.currentRow.jobNo) {
              if (this.action === 'look') {
                this.reset([item])
                this.againShow(action || 'look')
              } else {
                this.$message.warning(this.$t('queryJob.DataChangedToReopen'))
              }
              action = ''
            } else {
              this.reset([item])
            }
          }
        }
      }
      if (action) {
        this.againShow(action)
      }
    }
  },
  deactivated() {
    if (this.openMultiple) {
      LocalStorageUtilsNew.setConfiguration('SI_LEFT_SIZE', this.$refs.cargoLeftRightResize.$refs.left.style.width)
    }
  },
  updated() {
    if (!this.$refs['tabs']) {
      return
    }
    const panes = this.$refs['tabs'].panes
    const tabNameSet = new Set()
    for (const item of panes) {
      tabNameSet.add(item.name)
    }
    // 将失效的tab名称从pendTabSet中移除
    for (const item of [...this.pendTabSet]) {
      if (!tabNameSet.has(item)) {
        this.pendTabSet.delete(item)
      }
    }
  },
  methods: {
    // 重置行数据
    reset(rows) {
      for (const row of rows) {
        // 标识为脏数据
        row.version = 0
        // 重置子表数据
        for (const key in row) {
          if (typeof row[key] === 'object') {
            row[key] = ''
          }
        }
        row.isCompleteRow = false
      }
    },
    // 公用方法，进入详情每个页签都会调用
    async onShow(action, rowData, selectedRow) {
      this.imCacheKey = sessionStorage.getItem('imCacheKey')
      if (action === 'edit') { // 编辑时，重新加载业务和费用
        selectedRow.version = 0
        selectedRow.charges = ''
        selectedRow.seaCargoDoc = ''
        selectedRow.isCompleteRow = false
      }
      if (!selectedRow.masterFlag) {
        this.bookingBtn = selectedRow.containerLoadType === 'LCL'
      } else {
        this.bookingBtn = false
      }
      this.isCrossTenantSEToSI = false
      this.visible = true
      this.context.loading = true
      this.$store.dispatch('app/setCanCloseModule', action === 'look')
      if (Number(this.config.get('MultipleJobViewMode')) !== 0 && this.$route && this.$route.query) {
        JobUtils.setCanCloseModuleMap(SystemConstants.CLOSE_MODULE_SI, action === 'look', this.$route.query.key || '')
      } else {
        JobUtils.setCanCloseModuleMap(SystemConstants.CLOSE_MODULE_SI, action === 'look', '')
      }
      this.action = action
      /* 先将原始数据赋给currentRow、paramsOfTab，让页面先展示 */
      this.currentRow = selectedRow
      this.paramsOfTab = this.currentRow
      this.$nextTick(() => {
        this.resetActiveTabName()
      })
      this.isOtherEdit = action === 'split' || action === 'copy'
      if (selectedRow.uuid) {
        this.rowData = lodash.cloneDeep(rowData)
      } else {
        if (!selectedRow.lclNumber && !this.isOtherEdit) {
          await Promise.all([this.context.getDefaultSeaImportJob(), this.context.getCurrentOfficeOpDepartment(this.user.userId, this.$store.getters.currentOfficeId)])
          // 新建job 默认值&赋值默认值
          this.buildNewRow(selectedRow)
        }
        // CARGO-53866 东丽 新增复制业务 销售默认带入当前登录人
        await JobUtils.loadingDlwlSales(selectedRow, this)
        if (!Object.prototype.hasOwnProperty.call(selectedRow, 'path')) selectedRow.path = ''
        this.rowData = [...lodash.cloneDeep(rowData), selectedRow]
      }
      this.$nextTick(async() => {
        if (this.gridApi) {
          await sleep(100)
        } else {
          // 等待gridApi被赋值
          await ensureExecuteSuccess(() => this.gridApi)
        }
        await this.onRowClicked({ data: selectedRow })
      })

      if (action === 'look') {
        this.getImGroupFunc({ data: selectedRow })
        const cfg = LocalStorageUtils.getConfiguration('SISopStatusPopupVisible')
        this.sopStateDialog.visible = !!cfg
        const logDialogVisible = LocalStorageUtilsNew.getConfiguration('SIDataUpdateLogDialogVisible')
        this.dataUpdateLogDialog.visible = !!logDialogVisible
      }
      JobUtils.getReceiptCharges(this.rowData)
    },
    // sop 双击事件
    onBtnListDoubleClicked() {
      LocalStorageUtils.setConfiguration('SISopStatusPopupVisible', true)
      this.sopStateDialog.visible = true
      this.sopStateDialog.defaultIsExpand = true
      this.sopStateDialog.isNeedExpand = true
    },
    // sop 关闭处理
    sopStateDialogClose() {
      this.sopStateDialog.defaultIsExpand = true
      LocalStorageUtils.setConfiguration('SISopStatusPopupVisible', false)
    },
    // log 关闭处理
    dataUpdateLogDialogClose() {
      this.dataUpdateLogDialog.defaultIsExpand = true
      LocalStorageUtilsNew.setConfiguration('SIDataUpdateLogDialogVisible', false)
    },
    resetActiveTabName() {
      if (this.isNew) {
        this.activeTabName = this.getDefaultActiveName()
      } else {
        const activePanes = this.$refs['tabs'].panes.filter(p => p.active)
        if (activePanes && activePanes.length === 0) {
          this.activeTabName = this.getDefaultActiveName()
        }
      }
    },
    getDefaultActiveName() {
      const firstPane = this.$refs['tabs'].panes[0]
      return firstPane ? firstPane.name : ''
    },
    // 加载配置项
    loadConfigData() {
      const { config } = this
      this.btnInfo.visible.sendBackBookingButton = Number(config.get('sendBackBookingButton')) === 1
      this.commonInfo.reqInputCharge = Number(config.get('saveCharge')) === 1
      this.commonInfo.isBookingFeeMandatoryAppliedGlobally = Number(config.get('isBookingFeeMandatoryAppliedGlobally')) === 1
      this.commonInfo.allSubmitFcl = Number(config.get('AllSubmitFcl')) === 1
      this.commonInfo.isPrintCommit = Number(config.get('isPrintCommit')) === 1
      this.commonInfo.isCopySellingCharge = Number(config.get('isCopySellingCharge')) === 1
      this.commonInfo.needConfirmDuplicateWarehouseNo = Number(config.get('needConfirmeDuplicateWarehouseNo')) === 1
      this.commonInfo.synchronousShipperCodeAndConsigneeCodeAndNotifyCode = Number(config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
      this.commonInfo.toExoSystemJYD = config.get('ToExoSystem') === 'JYD'
      this.commonInfo.sendBranchSelectObjectOrigin = config.get('SendBranchSelectObject')
      this.readSendBranchSelectObject()
      this.commonInfo.openHecConfig = Number(config.get('openHecConfig')) === 1
      this.commonInfo.showTruckingBySIMaster = Number(config.get('showTruckingBySIMaster')) === 1
      this.useOrderCenterMode = Number(config.get('useOrderCenterMode')) === 1
      this.useOrderCenterBranch = Number(config.get('orderCenterBranch')) === 1
      this.bookingEDIApiOpen = Number(config.get('BookingEDIApiOpen')) !== 0
      this.combinedManifest = Number(config.get('CombinedManifest')) === 1
    },
    readSendBranchSelectObject() {
      this.sendBranchWindow.items = []
      let arr = this.commonInfo.sendBranchSelectObjectOrigin
      if (arr.includes(2)) {
        this.sendBranchSelectObject = 2
        arr = [0, 1]
      } else {
        this.sendBranchSelectObject = arr[0] || 0
      }
      for (const selectObject of arr) {
        this.sendBranchWindow.items.push({
          selectObject,
          userId: 0,
          departmentId: 0,
          departmentOfficeId: 0
        })
      }
    },
    // 新增时 填充默认值
    buildNewRow(row) {
      const rowBackup = lodash.cloneDeep(row)
      const isNew = !Object.keys(row).length
      // 填充默认值
      new SeaImportJob(row).fillDefaultValue()
      row.path = ''
      row.lob = this.lob
      row.booking = true // 默认勾选订舱
      row.cargoType = 'GC'
      row.cargoSource = 'NC'
      row.typeHBL = 1
      row.typeMBL = 1
      row.portCode = this.$t('SeaExport.PlsSeeEIR')
      row.paymentTermHBL = 'PP'
      row.paymentTermMBL = 'PP'
      row.opOffice = this.office.officeId
      row.taxNature = 0
      // row.loadingPortCode = this.office.seaport
      if (this.context.opDepartment) {
        row.op = this.user.userId
        if (this.user.defaultDepId > 0 && this.user.defaultOfficeId === this.office.officeId) {
          row.opDepartment = this.user.defaultDepId
        } else {
          row.opDepartment = this.context.opDepartment.departmentId
        }
      }
      const tradeTerms = getCacheListByKey(basicCacheKeys.basic_data_TradeTerm)
      if (tradeTerms.length > 0) {
        row.tradeTerm = tradeTerms[0].code
      }

      Object.assign(row, this.context.defaultSeaImportJob)
      // 进口 目的港=卸货港 ，默认赋值 避免主票上新增小票 生成warehouseNo 用到目的港code
      if (!row.destinationPortCode) {
        row.destinationPortCode = row.dischargingPortCode
      }
      if (row.masterFlag) {
        row.paymentTermHBL = ''
        row.freightTermHBL = ''
      }
      if (!isNew && !row.masterFlag) {
        Object.keys(row).forEach(key => {
          if (rowBackup[key]) {
            row[key] = rowBackup[key]
          }
        })
      }
      // CARGO-30761 主单/分单运输条款优先取用户保存默认值
      const shippingTermList = getCacheListByKey(basicCacheKeys.basic_data_ShippingTerm)
      if (shippingTermList && shippingTermList.length > 0) {
        if (!row.freightTermMBL) {
          for (const shippingTerm of shippingTermList) {
            const shippingTermOperationTypes = shippingTerm.shippingTermOperationTypes
            let isFind = false
            if (shippingTermOperationTypes && shippingTermOperationTypes.length > 0) {
              for (const item of shippingTermOperationTypes) {
                if (item.containerLoadType === row.containerLoadType && item.mbl && item.lob === 'SI') {
                  isFind = true
                  break
                }
              }
            }
            if (isFind) {
              row.freightTermMBL = shippingTerm.code
              break
            }
          }
        }
        if (!row.masterFlag && !row.freightTermHBL) {
          for (const shippingTerm of shippingTermList) {
            const shippingTermOperationTypes = shippingTerm.shippingTermOperationTypes
            let isFind = false
            if (shippingTermOperationTypes && shippingTermOperationTypes.length > 0) {
              for (const item of shippingTermOperationTypes) {
                if (item.containerLoadType === row.containerLoadType && !item.mbl && item.lob === 'SI') {
                  isFind = true
                  break
                }
              }
            }
            if (isFind) {
              row.freightTermHBL = shippingTerm.code
              break
            }
          }
        }
      }
    },
    // 设置选中行
    setGridSelect(row) {
      console.log('setGridSelect', row)
      const nodes = this.gridApi.getModel().rowsToDisplay
      // this.$logger.log('nodes', nodes)
      // this.$logger.log('this.rowData', this.rowData)
      for (const item of nodes) {
        if (!item.data) {
          continue
        }
        const itemKey = item.data.jobUuid || item.data.uuid
        const rowKey = row.uuid || row.jobUuid
        if (itemKey === rowKey || !itemKey) {
          this.gridApi.setFocusedCell(item.rowIndex, this.gridApi.columnController.getAllDisplayedColumns()[0])
          this.gridApi.ensureIndexVisible(item.rowIndex)
          break
        }
      }
    },
    tabToNextCell(e) {
      if (!e.nextCellPosition) {
        return e.previousCellPosition
      }
      const { column, rowIndex } = e.nextCellPosition
      if (this.action !== 'look' || !column) return
      const { rowsToDisplay } = this.gridOptions.api.getModel()
      const curNode = rowsToDisplay[rowIndex]
      this.changeJob(curNode)
      return e.nextCellPosition
    },
    onCellClicked(event) {
      this.changeJob(event)
      this.getImGroupFunc(event)
    },
    async onCellDoubleClicked(event) {
      let data = event.data
      // 若选中提单拆并单,则需要找到其父级job
      if (data.dataType && Number(data.dataType) !== 1 && Number(data.dataType) !== 2 && data.jobUuid) {
        for (const item of this.rowData) {
          if (item.uuid === data.jobUuid) {
            data = item
            break
          }
        }
      }
      if (this.openMultiple && data.jobNo === this.$route.query.key) {
        return
      }
      this.gridApi.setRowData(this.rowData)
      this.setGridSelect(this.currentRow)
      if (this.viewJobNoSet.has(data.jobNo)) {
        this.$router.push({ name: 'SiBooking', query: { openNew: true, key: data.jobNo }})
      } else {
        if (this.viewJobNoSet.size + 1 > 10) {
          this.$message.warning(this.$t('queryJob.TenTicketsAtTheSameTime'))
          return
        }
        const rowData = deepCopy(this.rowData)
        this.reset(rowData)
        const action = Number(cache.config.get('JobDirectEditingStatus')) === 1 && data.jobState === 0 && !JobUtils.isBlockJob(data) && (await SecurityUtil.canEdit(new SeaImportJob(data))) ? 'edit' : 'look'
        this.$router.push({ name: 'SiBooking', query: { openNew: true, key: data.jobNo }, params: { rowData, action, activeTabName: this.activeTabName }})
      }
    },
    // 左侧列表切换job
    async changeJob(event) {
      let result = event.data
      // 若选中提单拆并单,则需要找到其父级job
      if (result.dataType && Number(result.dataType) !== 1 && Number(result.dataType) !== 2 && result.jobUuid) {
        for (const item of this.rowData) {
          if (item.uuid === result.jobUuid) {
            result = item
            break
          }
        }
      }
      if (result) {
        const action = Number(cache.config.get('JobDirectEditingStatus')) === 1 && result.jobState === 0 && !JobUtils.isBlockJob(result) && (await SecurityUtil.canEdit(new SeaImportJob(result))) ? 'edit' : 'look'
        // 尾程商务/海外跟单详情页：在当前页面切换数据，不跳转
        if (this.openMultiple && this.$route.path.startsWith('/DestinationBusiness')) {
          // 参考海运订舱详情页的处理方式
          // 重新数据库中加载job，清空对象类型属性避免响应式更新导致的空白
          this.isGetNewJobInfoFromDb = true
          result.isCompleteRow = false
          result.version = 0
          for (const key in result) {
            if (typeof result[key] === 'object') {
              result[key] = ''
            }
          }
          this.action = action
          await this.onRowClicked({ data: result })
          // 更新当前页签标题为切换后的业务编号，避免新开页签
          this.$store.dispatch('tagsView/updateViewTitle', { view: this.$route, key: result.jobNo })
        } else if (this.openMultiple) {
          if (result.jobNo === this.$route.query.key) {
            return
          }
          this.gridApi.setRowData(this.rowData)
          this.setGridSelect(this.currentRow)
          if (this.viewJobNoSet.has(result.jobNo)) {
            this.$router.push({ name: 'SiBooking', query: { openNew: true, key: result.jobNo }})
          } else {
            if (Number(this.config.get('MultipleJobViewMode')) === 2) {
              const rowData = deepCopy(this.rowData)
              this.reset(rowData)
              this.$router.push({ name: 'SiBooking', query: { openNew: true, key: result.jobNo }, params: { rowData, action, activeTabName: this.activeTabName, replace: true }})
            }
          }
        } else {
          if (this.viewJobNoSet.has(result.jobNo)) {
            this.gridApi.setRowData(this.rowData)
            this.setGridSelect(this.currentRow)
            this.$router.push({ name: 'SiBooking', query: { openNew: true, key: result.jobNo }})
          } else {
            // 重新数据库中加载job
            result.isCompleteRow = false
            result.version = 0
            for (const key in result) {
              if (typeof result[key] === 'object') {
                result[key] = ''
              }
            }
            this.action = action
            this.onRowClicked({ data: result })
          }
        }
      }
    },
    // 行点击
    async onRowClicked(event) {
      if (!event.data) {
        return
      }
      console.log('onRowClicked', event.data)
      this.context.loading = true
      this.unread = false
      if (!event.data) {
        this.context.loading = false
        return
      }
      let job = event.data
      // 若选中提单拆并单,则需要找到其父级job
      if (job.dataType && Number(job.dataType) !== 1 && Number(job.dataType) !== 2 && job.jobUuid) {
        for (const item of this.rowData) {
          if (item.uuid === job.jobUuid) {
            job = item
            break
          }
        }
      }
      this.setGridSelect(job)
      let loadCooperate = false
      // 加载job详细信息
      if (!job.isCompleteRow) {
        const jobModel = new SeaImportJob(job)
        if (job.uuid) {
          await jobModel.loadJobRelated({
            job: !(jobModel.version >= 1), // 脏数据，需要重新载入
            seaEQ: true,
            lclSlaves: job.masterFlag,
            charges: true,
            warehouseIn: job.masterFlag,
            warehouseInfo: true,
            trucking: true,
            lclMaster: !job.masterFlag,
            seaCargoDoc: true,
            containerUsages: true,
            containers: true,
            cargoBulkDetail: !job.masterFlag,
            surchargeTerms: !job.masterFlag,
            orderCenterMode: this.useOrderCenterMode,
            cooperateBranchId: this.cooperateBranchId
          })
          loadCooperate = true
          // 非主票 组装 containers.containerUsage  同 job.containerUsages 指向同一usage
          if (!jobModel.masterFlag) {
            ContainerUtil.buildContainerUsages(job)
          }

          if (!job.path) {
            this.setBasicData(job)
            this.gridApi.refreshCells({ force: true })
          }

          // 检查主票下的小票，如果主票有修改，同步将小票放在修改列表中
          if (job.lclSlaves && job.lclSlaves.length > 0) {
            const index = this.saveJobNos.findIndex(p => p.uuid === job.uuid)
            if (index >= 0) {
              for (const slave of job.lclSlaves) {
                const row = this.rowData.find(p => p.uuid === slave.uuid)
                if (row) {
                  for (const key in slave) {
                    if (typeof row[key] === 'object' || key === 'version') {
                      continue
                    }
                    row[key] = slave[key]
                  }
                  this.saveJobNos.push(row)
                }
              }
            }
          }
        } else {
          jobModel.seaEQ = jobModel.seaEQ || []
          jobModel.lclSlaves = jobModel.lclSlaves || []
          jobModel.charges = jobModel.charges || []
          jobModel.warehouseIn = jobModel.warehouseIn || []
          jobModel.warehouseInfo = jobModel.warehouseInfo || []
          jobModel.trucking = jobModel.trucking || []
          jobModel.seaCargoDoc = jobModel.seaCargoDoc || []
          jobModel.containerUsages = jobModel.containerUsages || []
          jobModel.containers = jobModel.containers || []
          jobModel.cargoBulkDetail = jobModel.cargoBulkDetail || []
          jobModel.surchargeTerms = jobModel.surchargeTerms || []
        }
        job.usCustomsClearanceList = ''
        job.truckingPage = false
        job.isCompleteRow = true
        if (job.warehouseInfo && job.warehouseInfo.length > 0) {
          job.warehouseName = job.warehouseInfo[0].warehouseName
        } else {
          job.warehouseName = ''
        }
        // 需重新构造对象，以便新增加的属性可以被vue监听到
        const newData = { ...job }
        /* 替换旧数据 */
        const index = this.rowData.findIndex(p => p.uuid === job.uuid)
        const node = this.gridApi.rowModel ? this.gridApi.rowModel.rowsToDisplay.find(p => p.data.uuid === job.uuid) : null
        if (index >= 0 && node) {
          this.rowData[index] = newData
          node.data = newData
          job = newData
        }
      }
      // 协作分公司信息
      if (this.useOrderCenterMode) {
        if (loadCooperate && job.cooperate && job.cooperate.uuid) {
          console.log('job.cooperate===', job.cooperate)
          // 记录原值
          job.opOffice_original = job.opOffice // 分公司
          job.op_original = job.op // 操作
          job.csr_original = job.csr // 客服
          job.overseaOp_original = job.overseaOp // 海外操作
          job.dc_original = job.dc // 单证
          job.planner_original = job.planner // 航线负责人
          job.opDepartment_original = job.opDepartment // 操作部门
          //
          job.opOffice = job.cooperate.branchId // 分公司
          job.op = job.cooperate.opId // 操作
          job.csr = job.cooperate.csrId // 客服
          job.overseaOp = job.cooperate.overseaOp // 海外操作
          job.dc = job.cooperate.dcId // 单证
          job.planner = job.cooperate.planner // 航线负责人
          job.opDepartment = job.cooperate.opDepartment // 操作部门
          JobUtils.convertJobFromCooperateInfo(job, job.cooperate)
          //
          job.cooperateUuid = job.cooperate.uuid
          job.cooperateCooperateStatus = job.cooperate.cooperateStatus
          job.cooperateBusinessType = job.cooperate.businessType
        }
      }
      this.currentRow = job
      this.initInfo()
      this.resetParamsOfTab()
      this.pendTabSet.clear()
      this.context.modifiedData = {}
      this.processingPromiseList = []
      if (!event.skipTabHandle) {
        this.$nextTick(() => {
          this.resetActiveTabName()
          this.handleTabClick()
          this.context.loading = false
        })
      }
      if (this.currentRow.uuid) {
        // 判断是否为跨租户海出转海进
        this.checkCrossTenantSEToSI()
        this.loadCrossTenantSyncHistory()
      }
    },
    resetParamsOfTab() {
      if (this.action === 'edit') {
        this.paramsOfTab = deepCopy(this.currentRow)
      } else {
        this.paramsOfTab = this.currentRow
      }
    },
    beforeLeaveTab(activeName, oldActiveName) {
      // 小票到主票 || 主票到小票 切换 不执行 endTabHandler
      if ((activeName === 'basicTab' && oldActiveName === 'masterBasicTab') || (activeName === 'masterBasicTab' && oldActiveName === 'basicTab')) {
        return
      }
      if (oldActiveName) {
        this.endTabHandler(oldActiveName)
      }
      return true
    },
    // tab页签结束后的处理
    async endTabHandler(tabName) {
      if (this.action === 'look') {
        return
      }
      const tab = this.$refs[tabName]
      if (!tab) {
        return
      }
      if (tab.endTabHandler && typeof tab.endTabHandler === 'function') {
        const result = tab.endTabHandler()
        if (result instanceof Promise) {
          await result
        }
      }
    },
    // tab页签切换
    handleTabClick() {
      this.$nextTick(() => {
        const oldSize = this.pendTabSet.size
        this.pendTabSet.add(this.activeTabName)
        const isRefresh = this.pendTabSet.size > oldSize
        this.$refs[this.activeTabName].onShow(this.paramsOfTab, isRefresh)
      })
    },
    // 整拼类型切换
    containerLoadTypeEvent(data) {
      if (this.masterFlag) {
        this.activeTabName = 'masterBasicTab'
      } else {
        this.activeTabName = 'basicTab'
      }
      // 清空pendTabSet.size 用于刷新
      this.pendTabSet = new Set()
      this.handleTabClick()
    },
    // 基本页签内，复选框控制部分页签显示隐藏的回调，控制this.pendTabSet集合元素
    tabNotCheckedCallBack(tabName) {
      this.pendTabSet.delete(tabName)
    },
    // 编辑
    async editHandler(action) {
      if (this.currentRow.jobState !== 0) {
        this.$message.info(this.$t('Message.ThisJobIsNotWorkingCanNotBeEdited'))
        return
      }
      if (!await SecurityUtil.canEdit(new SeaImportJob(this.currentRow))) {
        this.$message.info(this.$t('Message.NoPermissionToEditTheJob'))
        return
      }
      this.$refs.cargoLeftRightResize.hideLeft()
      this.btnGroupLook.style.display = 'none'
      this.btnGroupEdit.style.display = ''
      this.$refs.cargoButtonGroupSlider.resizeHandler()
      // 延迟执行，避免阻塞页面渲染
      setTimeout(() => {
        this.againShow(action)
      }, 5)
    },
    // 合并数据
    againShow(action, row) {
      this.action = action
      // 海进新增 add 时  需要弹出框 选择类型
      if (this.action === 'add') {
        this.$emit('add')
        return
      }
      const selectedRow = this.isNew ? row || {} : this.currentRow
      this.onShow(action, this.rowData, selectedRow)
    },
    triggerSaveEvent() {
      setTimeout(() => {
        this.saveEventFlag = true
      }, 5)
    },
    // 保存海运业务【保存业务相关数据】
    async save() {
      this.context.loading = true
      const loading = getLoading4Cxt(this)
      try {
        if (this.processingPromiseList.length > 0) {
          const processingPromiseList = [...this.processingPromiseList]
          for (const processingPromise of processingPromiseList) {
            try {
              await processingPromise
            } catch (err) {
              console.log(err)
            }
          }
        }
        // 当前页签结束后的处理
        await this.endTabHandler(this.activeTabName)
        const body = {}
        try {
          for (const item of [...this.pendTabSet, 'other']) {
            let tabData = null
            if (item !== 'other') {
            // 各页签的保存数据
              const getSubmitData = this.$refs[item].getSubmitData
              if (getSubmitData && typeof getSubmitData === 'function') {
              /* 获取各页签需要保存的数据 */
                const result = this.$refs[item].getSubmitData()
                if (result instanceof Promise) {
                  tabData = await result
                } else {
                  tabData = result
                }
              }
            } else {
            // 被联动修改了的数据
              tabData = this.context.modifiedData
            }

            if (!tabData) continue
            this.$logger.log('tabData' + item, tabData)
            // 将不同页签相同key的集合进行数据合并
            for (const key in tabData) {
              const tabValue = tabData[key]
              // this.$logger.log('tabValue：' + item, tabValue)
              if (!tabValue) continue // 判断当前页签所传的数据是否有效，无效则不需要合并
              const bodyValue = body[key]
              // this.$logger.log('bodyValue：' + item, bodyValue)
              if (!bodyValue || !Object.prototype.hasOwnProperty.call(body, key)) continue // 判断body中是否存在该key，不存在或者无数据则由下面统一合并
              // 将数组进行合并
              if (Array.isArray(tabValue)) {
              //
                if (Array.isArray(bodyValue)) { // 这里面会将 uuid 相同的费用进行过滤，页签上的优先于 级联改动的数据
                  const bodyMap = new Map()
                  if (bodyValue.length > 0) {
                    for (const bodyKey of bodyValue) {
                      if (!bodyKey) continue
                      if (Object.prototype.hasOwnProperty.call(bodyKey, 'uuid') && bodyKey.uuid) bodyMap.set(bodyKey.uuid, bodyKey)
                    }
                  }
                  if (tabValue.length > 0) {
                    for (const tabKey of tabValue) {
                      if (!tabKey || bodyValue.includes(tabKey)) continue
                      if (Object.prototype.hasOwnProperty.call(tabKey, 'uuid') && tabKey.uuid && bodyMap.has(tabKey.uuid)) continue
                      bodyValue.push(tabKey)
                    }
                  }
                } else {
                  tabValue.push(bodyValue)
                  body[key] = tabValue
                }
                delete tabData[key]
              }
            }
            // 去除提单（MBL、HBL）中的重复值
            if (body.seaCargoDoc) {
              const list = body.seaCargoDoc
              const mblList = []
              const hblList = []
              for (let i = list.length - 1; i >= 0; --i) {
                if (list[i].docType === CargoDocConsts.MBL) {
                  mblList.push(list[i])
                  list.splice(i, 1)
                } else if (list[i].docType === CargoDocConsts.HBL) {
                  hblList.push(list[i])
                  list.splice(i, 1)
                }
              }
              if (mblList.length > 0) {
                list.push(mblList.find(p => p.uuid) || mblList[mblList.length - 1])
              }
              if (hblList.length > 0) {
                list.push(hblList.find(p => p.uuid) || hblList[hblList.length - 1])
              }
            }
            // 待删除的提单
            if (this.paramsOfTab.deletedCargoDocs) {
              body.seaCargoDoc = body.seaCargoDoc || []
              for (const deletedCargoDoc of this.paramsOfTab.deletedCargoDocs) {
                deletedCargoDoc.deleted = true
                body.seaCargoDoc.push(deletedCargoDoc)
              }
            }
            Object.assign(body, tabData)
            this.$logger.log('页签名称：' + item, tabData)
          }

          // 清空子表数据【原本是在各页签里面的，现在移到公共的地方来】
          if (Reflect.has(body, 'job') && body.job) {
            if (body.job === this.paramsOfTab) {
              body.job = { ...body.job }
            }
            for (const key in body.job) {
            // 这里必须要删除，不能将其置为空或者undefined，否则复制或者拆分主票没法赋值
              if (typeof body.job[key] === 'object') delete body.job[key]

              // 保存时需要将sop显示列排除
              if (key.indexOf('_sop_') !== -1 && key.startsWith('_sop_')) delete body.job[key]
            }
          }

          // 复制、拆分主票保存前处理【未点击页签的数据也需要保存】
          this.doNotClickTabData(body)

          // 主票 新增/加入小票 使用
          if (this.currentRow.lclNumber) {
            const job = this.currentRow
            if (job.warehouseInfo) {
              Object.assign(body, { warehouseInfo: job.warehouseInfo })
            }
            if (job.trucking) {
              Object.assign(body, { truckingInfo: job.trucking })
            }
            if (job.seaCargoDoc) {
              Object.assign(body, { seaCargoDoc: job.seaCargoDoc })
            }
          }

          this.cleanCircleObject(body)
          // 还原接单分公司
          if (this.useOrderCenterMode) {
            if (body.job && body.job.cooperateUuid) {
              body.job = { ...body.job }
              body.job.opOffice = body.job.opOffice_original || body.job.opOffice // 分公司
              body.job.op = body.job.op_original || body.job.op // 操作
              body.job.csr = body.job.csr_original || body.job.csr // 客服
              body.job.overseaOp = body.job.overseaOp_original || body.job.overseaOp // 海外操作
              body.job.dc = body.job.dc_original || body.job.dc // 单证
              body.job.planner = body.job.planner_original || body.job.planner // 航线负责人
              body.job.opDepartment = body.job.opDepartment_original || body.job.opDepartment // 操作部门
              JobUtils.restoreJobFromCooperateInfo(body.job)
            }
          }
          if (body.containerUsages) {
            for (const item of body.containerUsages) {
              if (item.container && item.container.containerUsage === '') { // 避免后台fastjson解析报错
                item.container.containerUsage = null
              }
            }
          }
          JobUtils.handleChargeForSave(body)
          this.$logger.log('body', body)
        } catch (err) {
          if (err instanceof TabError) {
            this.activeTabName = err.tabName
            if (err.message) {
              this.$message.warning({ dangerouslyUseHTMLString: true, message: err.message })
            }
            return
          }
          throw err
        }
        // 在保存前进行校验
        if (!(await this.pm.checkBeforeSave(body.job))) {
          return
        }

        // todo 待验证
        if (Reflect.has(body, 'seaCargoDoc') && body.seaCargoDoc && Reflect.has(body, 'containerUsages') && body.containerUsages) {
          for (const cd of body.seaCargoDoc) {
            if (cd.docType === 'HBL') {
              const s = SeaExportUtils.getContainerDesc(body, cd.printParam3)
              if (s != null && (cd.container === '' || cd.container == null)) {
                cd.container = s.toLocaleUpperCase()
              }
            }
          }
        }

        // 获取复制份数
        if (Reflect.has(body, 'job') && Reflect.has(body.job, 'copyNum') && Number(body.job.copyNum) > 1) {
          this.copyJobNum = Number(body.job.copyNum)
        }

        // 复制时校验费用名称是否被禁用
        if (this.action === 'copy') {
          const flag = await JobUtils.checkChargeItemDisabled(this, body.charges)
          if (!flag) {
            return
          }
        }
        // 若为自揽货 清空指定货代理取值
        if (body.job && body.job.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
          body.job.designationAgent = 0
        }
        // 后端触发SOP使用
        if (!this.isNew) body.jobUuid = this.job.uuid

        // 保存业务时判断缓存M单和H单的提单方式是否变更
        if (body.seaCargoDoc && Number(this.config.get('ReleaseTypeDefaultValue')) === 4) {
          for (const doc of body.seaCargoDoc) {
            if (doc.docType === 'MBL') {
              const type = LocalStorageUtilsNew.getConfiguration('SI_MBL_BL_MODEL')
              if (doc.releaseType && doc.releaseType !== type) {
                LocalStorageUtilsNew.setConfiguration('SI_MBL_BL_MODEL', doc.releaseType)
              }
            } else if (doc.docType === 'HBL') {
              const type = LocalStorageUtilsNew.getConfiguration('SI_HBL_BL_MODEL')
              if (doc.releaseType && doc.releaseType !== type) {
                LocalStorageUtilsNew.setConfiguration('SI_HBL_BL_MODEL', doc.releaseType)
              }
            }
          }
        }

        // 获取业务对应的sop模板，若不一致，则提醒是否更换，若一致不处理，若新增，则
        await SopUtil.checkSopTemplate(body.job, this, null, null, this.sopTemplateConfig)

        // CARGO-16870 验证规则节点增加“业务保存”
        const useCheckRule = Number(this.config.get('useCheckRule')) === 1
        if (useCheckRule && body && body.hasOwnProperty('job') && body.job) {
          const hasCheckRuleForSaveJob = await JobUtils.hasCheckRuleCondition(useCheckRule, CheckRuleConstants.NODE_SAVE_BUSINESS.code, this.$store.getters.currentOfficeId)
          if (hasCheckRuleForSaveJob) {
            const result = await JobUtils.checkBySaveJobNode({ ...body, charges: this.paramsOfTab.charges }, this.job.lob, CheckRuleConstants.NODE_SAVE_BUSINESS.code)
            if (result.needShowDialog) {
              loading.close()
              const callBack = async() => { await this.continueSaving(body, loading, true) }
              this.checkingSaveJobWindow.checkNode = CheckRuleConstants.NODE_SAVE_BUSINESS.code
              this.checkingSaveJobWindow.rowData = result.rowData
              this.checkingSaveJobWindow.callBack = callBack
              this.checkingSaveJobWindow.visible = true
            } else {
              await this.continueSaving(body, loading, false)
            }
          } else {
            await this.continueSaving(body, loading, false)
          }
        } else {
          await this.continueSaving(body, loading, false)
        }
      } finally {
        loading.close()
        this.context.loading = false
      }
    },
    saveResultHandler(job) {
      // todo 保存成功后处理逻辑，其他的后端处理
      // CARGO-6211 海运进口订舱录入业务保存后字段推送到SAP
      sendJobSiRui({ jobUuid: this.currentRow.uuid }).then(res => {
        const message = res.data
        if (message) {
          this.$message.info('思锐委托单推送失败,请联系工作人员排查:' + message)
        }
      })

      // 同步仓库
      syncLclSlaveJobInfo(job)
    },

    refreshLeftTree() {
      // 保存/提交操作 的是 小票或者主票 因同步 主票件重尺，小票etd 等 刷新左侧列表避免未重新加载
      if (this.currentRow.masterFlag) {
        for (const job of this.rowData) {
          if (job.lclMasterUuid === this.currentRow.uuid) {
            job.isCompleteRow = false
            job.version = 0 // 标识为脏数据，需要重新载入
            // 重置子表数据
            for (const key in job) {
              if (typeof job[key] === 'object') {
                job[key] = ''
              }
            }
          }
        }
        this.gridApi.refreshCells({ force: true })
      }
      if (!StrUtils.isEmpty(this.currentRow.lclMasterUuid)) {
        const masterJob = this.rowData.find(item => item.uuid === this.currentRow.lclMasterUuid)
        if (masterJob) {
          masterJob.isCompleteRow = false
          masterJob.version = 0 // 标识为脏数据，需要重新载入
          // 重置子表数据
          for (const key in masterJob) {
            if (typeof masterJob[key] === 'object') {
              masterJob[key] = ''
            }
          }
        }
        this.gridApi.refreshCells({ force: true })
      }
    },
    // 复制、拆分主票保存前处理【未点击页签的数据也需要保存】
    doNotClickTabData(body) {
      const isCopy = this.action === 'copy'
      const isSplit = this.action === 'split'
      const job = this.currentRow
      if (!body || !job || (!isCopy && !isSplit)) return
      // 复制独有
      if (isCopy) {
        if (!Object.prototype.hasOwnProperty.call(body, 'seaCargoDoc') && job.seaCargoDoc && job.seaCargoDoc.length > 0) {
          Object.assign(body, { seaCargoDoc: job.seaCargoDoc })
        }
        if (!Object.prototype.hasOwnProperty.call(body, 'warehouseInfo') && job.warehouseInfo && job.warehouseInfo.length > 0) {
          Object.assign(body, { warehouseInfo: job.warehouseInfo })
        }
        if (!Object.prototype.hasOwnProperty.call(body, 'trucking') && job.trucking && job.trucking.length > 0) {
          Object.assign(body, { truckingInfo: job.trucking })
        }
        if (!Object.prototype.hasOwnProperty.call(body, 'manifestInfos') && job.manifestInfos && job.manifestInfos.length > 0) {
          Object.assign(body, { manifestInfos: job.manifestInfos })
        }
        if (!Object.prototype.hasOwnProperty.call(body, 'charges') && job.charges && job.charges.length > 0) {
          Object.assign(body, { charges: job.charges })
        }
      }

      // 拆分主票独有
      if (isSplit) {
        if (!Object.prototype.hasOwnProperty.call(body, 'lclSlaves') && job.lclSlaves && job.lclSlaves.length > 0) {
          Object.assign(body, { lclSlaves: job.lclSlaves })
        }
      }

      // 拆分主票或者复制共有
      if (!Object.prototype.hasOwnProperty.call(body, 'seaEQ') && job.seaEQ && job.seaEQ.length > 0) {
        Object.assign(body, { seaEQ: job.seaEQ })
      }
      if (!Object.prototype.hasOwnProperty.call(body, 'containers') && job.containers && job.containers.length > 0) {
        Object.assign(body, { containers: job.containers })
      }
      // containerUsages 的保存跟随 containers
      /* if (!Object.prototype.hasOwnProperty.call(body, 'containerUsages') && job.containerUsages && job.containerUsages.length > 0) {
        Object.assign(body, { containerUsages: job.containerUsages })
      }*/
    },
    // 清理循环引用
    cleanCircleObject(obj, level = 0, refMap = new Map()) {
      if (!(obj instanceof Object)) {
        return
      }
      if (level === 0) {
        refMap.set(obj, { level })
      }
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const item = obj[key]
          if (item instanceof Object) {
            const ref = refMap.get(item)
            if (ref) {
              if (level > ref.level) {
                if (obj instanceof Array) {
                  obj[key] = undefined
                } else {
                  delete obj[key]
                }
              } else if (level < ref.level) {
                if (ref.parent instanceof Array) {
                  ref.parent[ref.name] = undefined
                } else {
                  delete ref.parent[ref.name]
                }
                ref.level = level
                ref.parent = obj
                ref.name = key
              }
            } else {
              refMap.set(item, { level: level + 1, parent: obj, name: key })
              this.cleanCircleObject(item, level + 1, refMap)
            }
          }
        }
      }
      if (level === 0) {
        for (const arr of refMap.keys()) {
          if (arr instanceof Array) {
            // 从后向前删除，避免待删除元素的index发生变化
            for (let i = arr.length - 1; i >= 0; --i) {
              if (typeof arr[i] === 'undefined') {
                arr.splice(i, 1)
              }
            }
          }
        }
      }
    },
    // 保存剩下的复制业务【后台复制并保存】
    async saveCopyJobHandle(jobUuid, masterFlag, copyNum) {
      //
      const item = {}
      item.jobUuid = jobUuid
      item.branchId = this.$store.getters.currentOfficeId
      // 复制哪些页签的数据
      const lob = this.currentRow.lob
      if (masterFlag) {
        item.vesselEq = LocalStorageUtils.getConfiguration('COPY_VESSEL_EQ_' + lob + '_MASTER')
        item.mbl = LocalStorageUtils.getConfiguration('COPY_MBL_' + lob + '_MASTER')
        item.hbl = LocalStorageUtils.getConfiguration('COPY_HBL_' + lob + '_MASTER')
        item.charge = LocalStorageUtils.getConfiguration('COPY_CHARGE_' + lob + '_MASTER')
        item.prePlanBooking = LocalStorageUtils.getConfiguration('COPY_PRE_PLAN_BOOKING_' + lob + '_MASTER')
      } else {
        item.vesselEq = LocalStorageUtils.getConfiguration('COPY_VESSEL_EQ_' + lob)
        item.mbl = LocalStorageUtils.getConfiguration('COPY_MBL_' + lob)
        item.hbl = LocalStorageUtils.getConfiguration('COPY_HBL_' + lob)
        item.charge = LocalStorageUtils.getConfiguration('COPY_CHARGE_' + lob)
        item.prePlanBooking = LocalStorageUtils.getConfiguration('COPY_PRE_PLAN_BOOKING_' + lob)
      }
      item.copyNum = copyNum
      item.all = true
      item.copyOnly = true // 是否是复制业务，新增业务日志时使用
      item.masterFlag = masterFlag
      item.location = this.location
      await saveCopyJob(item).then(res => {
        const newJobList = res.data
        if (newJobList && newJobList.length > 0) {
          for (const copyJob of newJobList) {
            this.setBasicData(copyJob)
            this.saveJobNos.push(copyJob)
            copyJob.seaCargoDoc = ''
          }
          this.rowData = [...this.rowData, ...newJobList]
        }
        JobUtils.copyFailTip(copyNum, newJobList, this)
      })
    },
    // 给job设置基本信息
    setBasicData(jobData) {
      jobData.jobUuid = jobData.uuid
      jobData.parentUuid = jobData.uuid
      jobData.path = jobData.uuid
      jobData.dataType = 2 // 小票
    },
    // 保存剩下的新增小票业务【后台复制并保存】
    async saveLclJob(jobUuid, copyNum) {
      const item = {
        jobUuid,
        branchId: this.$store.getters.currentOfficeId,
        copyNum,
        all: true,
        copyOnly: false, // 是否是复制业务，新增业务日志时使用
        location: this.location
      }
      await saveCopyJob(item).then(res => {
        const newJobList = res.data
        if (newJobList && newJobList.length > 0) {
          for (const copyJob of newJobList) {
            this.setBasicData(copyJob)
            copyJob.jobUuid = copyJob.uuid
            copyJob.parentUuid = copyJob.lclMasterUuid
            copyJob.path = copyJob.lclMasterUuid + ',' + copyJob.uuid
            copyJob.dateType = 2 // 小票
            this.saveJobNos.push(copyJob)
          }
          this.rowData = [...this.rowData, ...newJobList]
        }
        JobUtils.copyFailTip(copyNum, newJobList, this)
      })
    },
    syncViewData(job) {
      let view = null
      if (this.openMultiple) {
        // 默认页签
        view = this.visitedViews.find(p => p.path === this.$route.path && (!p.query || !p.query.openNew || !p.query.key))
        if (view) {
          view.params.changedJobNos = view.params.changedJobNos || []
          view.params.changedJobNos.push(job.jobNo)
        }
      }
      // 多页签
      view = this.visitedViews.find(p => p.query && p.query.openNew && p.query.key && p.query.key === job.jobNo)
      if (view && (this.openMultiple && this.$route.query.key !== job.jobNo)) {
        view.params.isDirty = true
      }
    },
    // 取消编辑
    cancelEdit(done) {
      this.$confirm(this.$t('CargoMsg.Cargo_CCOCM'), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        JobUtils.setCanCloseModuleMap(SystemConstants.CLOSE_MODULE_SI, true, this.job ? this.job.jobNo || '' : '')
        if (typeof done === 'function') {
          done()
        }
      }).catch(() => { })
    },
    saveDefaultVal() {
      this.context.loading = true
      EntityDefaultValueUtil.getInstance().saveEntityDefaultValue(['Job', 'SeaImportJob'], this.paramsOfTab).then(() => {
        this.$message.success(this.$t('Message.DefaultValuesAreSavedSuccessfully'))
      }).finally(() => {
        this.context.loading = false
      })
    },
    // 刷新
    refresh() {
      this.currentRow.isCompleteRow = false
      this.currentRow.version = 0
      this.againShow(this.action, this.job)
    },
    // 加载完job走这里
    initInfo() {
      this.updateControlsState()
      this.checkCrossTenantHistoryState()
      this.showJobState()
      this.showJobTitle()
      this.checkProvisionPublishedStatus()
    },
    // 获取委托状态
    checkCrossTenantHistoryState() {
      if (this.job && this.job.uuid) {
        const company = this.context.companyList.find(p => p.cmpIdx === this.job.bookingAgent)
        if (company && company.relateTenantId > 0 && company.relateTenantOfficeId > 0) {
          // 获取最新的委托状态：已发送、已查看、拒绝为“委托"按钮
          queryLatestState(this.job.jobNo).then(res => { this.queryLatestStateHandler(res) })
        } else {
          this.btnInfo.privilege.consignationCrossEnable = false
        }
      }
    },
    // 根据委托状态处理相关权限
    queryLatestStateHandler(event) {
      const latestState = event.data
      this.btnInfo.privilege.crossMoreSign = latestState < 3
      const company = this.context.companyList.find(p => p.cmpIdx === this.job.bookingAgent)
      this.btnInfo.privilege.consignationCrossEnable = company && company.relateTenantId > 0 && company.relateTenantOfficeId > 0
      if (this.job.relatedJob && this.job.relatedJob && company.relateTenantId > 0 && !(latestState < 3)) {
        this.btnInfo.privilege.consignationCrossEnable = false
      }
    },
    // 刷新控制按钮
    updateControlsState() {
      const job = this.currentRow
      if (!job) return
      this.btnInfo.label.shutOutLabel = job.shutOut ? this.$t('SeaExport.CancelShutOut') : this.$t('SeaExport.ShutOut')// '取消退关' : '退关'

      this.btnInfo.visible.printFclProfit = false
      this.btnInfo.visible.printLclProfit = false
      this.btnInfo.enabled.printFclProfit = false
      this.btnInfo.enabled.printLclProfit = false
      if (this.btnInfo.privilege.button_JobBooking_PrintProfit) {
        if (job && !job.masterFlag && job.containerLoadType !== ContainerLoadType.LCL_CARGO_TYPE.code) {
          this.btnInfo.visible.printFclProfit = true
        } else {
          this.btnInfo.visible.printLclProfit = true
        }
        if (job && job.jobState !== 3) {
          if (this.btnInfo.visible.printFclProfit) {
            this.btnInfo.enabled.printFclProfit = true
          } else {
            this.btnInfo.enabled.printLclProfit = true
          }
        }
      }
      // if (job && job.jobState !== SystemConstants.SHUT_OUT && !job.masterFlag && (job.containerLoadType === ContainerLoadType.FCL_CARGO_TYPE.code || job.containerLoadType === ContainerLoadType.BB_CARGO_TYPE.code || job.containerLoadType === ContainerLoadType.BULK_CARGO_TYPE.code || job.containerLoadType === ContainerLoadType.SPECIAL_CARGO_TYPE.code)) {
      //   this.btnInfo.visible.printFclProfit = (this.btnInfo.privilege.button_JobBooking_Submit || this.btnInfo.privilege.button_JobBooking_PrintProfit)
      // }
      // // 拼箱主票
      // if (job && job.jobState !== SystemConstants.SHUT_OUT && (job.masterFlag || (job.containerLoadType === ContainerLoadType.BC_CARGO_TYPE.code))) {
      //   this.btnInfo.visible.printLclProfit = (this.btnInfo.privilege.button_JobBooking_Submit || this.btnInfo.privilege.button_JobBooking_PrintProfit)
      // }
      // 撤回权限按钮
      if (this.btnInfo.privilege.button_SEBooking_cancelProfit || this.btnInfo.privilege.button_JobBooking_Retract) {
        this.btnInfo.visible.printReturn = false
        if (!this.isEditing && job && job.jobState === SystemConstants.COMMITED) {
          this.btnInfo.visible.printReturn = true
        }
      }
      // 审核、退回、撤回、提交、预提交、主管提交
      this.btnInfo.visible.btnManagerAuditSubmit = this.btnInfo.privilege.button_JobBooking_ManagerAuditSubmit && job.manageAuditStatus === 1 && (job.jobState === SystemConstants.OPERATING || job.jobState === SystemConstants.PRE_COMMIT)
      this.btnInfo.visible.printReturn = job.jobState === SystemConstants.COMMITED && this.btnInfo.privilege.button_JobBooking_Retract
      this.btnInfo.visible.printReturnOperate = job.jobState === SystemConstants.PRE_COMMIT && this.btnInfo.privilege.button_JobBooking_ReturnToOperater
      this.btnInfo.visible.btnSubmit = (job.jobState === SystemConstants.OPERATING || job.jobState === SystemConstants.PRE_COMMIT) && this.btnInfo.privilege.button_JobBooking_Submit && (job.manageAuditStatus === 0 || job.manageAuditStatus === 3)
      this.btnInfo.visible.btnManagerSubmit = (job.jobState === SystemConstants.OPERATING || job.jobState === SystemConstants.PRE_COMMIT) && this.btnInfo.privilege.button_JobBooking_ManagerSubmit
      this.btnInfo.visible.btnPreSubmit = job.jobState === SystemConstants.OPERATING && this.btnInfo.privilege.button_JobBooking_PreSubmit && (job.manageAuditStatus === 0 || job.manageAuditStatus === 3)

      if (this.btnInfo.privilege.button_JobBooking_Retract) {
        this.btnInfo.visible.cancelReturn = false
        if (!this.isEditing && job && job.jobState === SystemConstants.COMMITED) {
          this.btnInfo.visible.cancelReturn = true
        }
      }
      this.changeSendBranchBtn()
      this.checkCrossTenantHistoryState()
    },
    // 内部委托按钮label控制
    changeSendBranchBtn() {
      // 发送分公司控制
      const _job = this.currentRow
      if (!_job) return
      const company = this.context.companyList.find(p => p.cmpIdx === _job.exChangeAgent)
      this.btnInfo.privilege.consignationEnable = company && company.linkedBranchId > 0 && company.linkedBranchId !== _job.opOffice && (!_job.relatedJob)
      if (company) {
        if (!this.btnInfo.privilege.consignationEnable && _job.relatedJob && _job.relatedJob !== '' && company.relateTenantId === 0) {
          this.btnInfo.label.btnEntrustment = this.$t('SeaExport.AssociationBusinessInformation')
          this.btnInfo.privilege.consignationEnable = !this.isEditing
        } else {
          this.btnInfo.label.btnEntrustment = this.$t('SeaExport.Consignation')
        }
      }
    },
    returnReview() {
      if (!this.currentRow) {
        return
      }
      JobUtils.batchReturnReview(this, [this.currentRow])
    },
    // 退关
    async toShutOut() {
      if (!this.currentRow) return
      const item = this.currentRow
      const validateClosingAccount = Number(this.config.get('ValidateClosingAccount')) === 1
      if (validateClosingAccount) {
        const flag = await JobUtils.checkJobOfClosingAccount(item.opOffice, item.etd)
        if (!flag) {
          return
        }
      }
      if (item.jobState === SystemConstants.SHUT_OUT) {
        await this.$confirm(this.$t('Message.ConfirmToCancelTheShutOut'))
        item.shutOut = false
        item.jobState = SystemConstants.OPERATING
        item.operateNameCode = SystemConstants.OPERATE_CANCEL_SHUTOUT.code
        shutOut({ anyStr: item.uuid, anyBool: item.shutOut, location: this.location }).then(res => this.printResultHandler(res))
      } else {
        await this.$confirm(this.$t('Message.ConfirmTheShutOut'))
        const loading = getLoading4Cxt(this)
        try {
          const body = { job: { ...item }}
          delete body.job.containerUsages
          delete body.job.containers
          const result = await JobUtils.checkBySaveJobNode(body, this.job.lob, CheckRuleConstants.NO_FEE_REFUND.code)
          if (result.needShowDialog) {
            loading.close()
            const callBack = async() => { canBatchShutout({ jobKeys: [item.uuid] }).then(res => this.shutoutCheckHandler(res)) }
            this.checkingSaveJobWindow.checkNode = CheckRuleConstants.NO_FEE_REFUND.code
            this.checkingSaveJobWindow.rowData = result.rowData
            this.checkingSaveJobWindow.callBack = callBack
            this.checkingSaveJobWindow.visible = true
          } else {
            canBatchShutout({ jobKeys: [item.uuid] }).then(res => this.shutoutCheckHandler(res))
          }
        } catch (err) {
          throw err
        } finally {
          loading.close()
        }
      }
    },
    shutoutCheckHandler(res) {
      const result = Number(res.data)
      if (result === 0) {
        const item = this.currentRow
        item.shutOut = true
        item.jobState = SystemConstants.SHUT_OUT
        item.charges = []
        item.operateNameCode = SystemConstants.OPERATE_SHUTOUT.code
        // 海进退关没有有无费用退关选项 默认无费用退关 anyBool传false
        shutOut({ anyStr: item.uuid, anyBool: false, location: this.location }).then(res => this.printResultHandler(res))
      } else if (result === 1) {
        this.$message.info(this.$t('Message.IfDoNotClearTheConfirmationFeeDoNotAllowFreeShutOut'))
      } else if (result === 2) {
        this.$message.info(this.$t('Message.PleaseRemoveThisTicketFromMblThenShutOut'))
      } else if (result === 3) {
        this.$message.info(this.$t('Message.PleaseRemoveAllTicketsFromMblThenShutOut'))
      }
    },
    // 作废/取消作废
    printResultHandler(result) {
      this.$message.success('操作成功')
      this.updateControlsState()
      // 重新加载
      this.refresh()
    },
    // 业务状态显示
    showJobState() {
      if (!this.currentRow || !this.currentRow.uuid) {
        this.commonInfo.jobState = ''
        this.commonInfo.jobLock = ''
        this.commonInfo.jobChangeState = ''
        return
      }
      this.commonInfo.jobState = ColumnUtils.getJobState(this.currentRow)
      this.commonInfo.jobLock = JobUtils.isBlockJob(this.currentRow) ? this.$t('Message.Locked') : ''
      // 防止同时显示两个已锁定状态
      if (this.commonInfo.jobState === this.commonInfo.jobLock && this.commonInfo.jobState === this.$t('Message.Locked')) {
        this.commonInfo.jobLock = ''
      }
      // 改单状态
      if (Number(this.config.get('IsCommittedAllowAddCost')) === 1) {
        this.commonInfo.jobChangeState = ColumnUtils.getJobChangeState(this.currentRow)
      }
    },
    formatJobTitleMblSegment(job) {
      if (!job) return '-'
      const m = job.mbl != null && String(job.mbl).trim() !== '' ? job.mbl : job.MBL_NO != null ? job.MBL_NO : ''
      const v = String(m).trim()
      return v || '-'
    },
    async showJobTitle() {
      const job = this.currentRow
      let jobTitle = Number(this.config.get('DetailTitleShowModel')) === 0 ? job.jobNo : StrUtils.toHalfwordUpperCase(job.mbl)
      if (job.customerId) {
        const cmp = this.context.companyList.find(p => p.cmpIdx === job.customerId)
        if (cmp) {
          const creditTerm = await JobUtils.getSettlementTypeByJobInformation(job, 'customerId')
          const billingType = await JobUtils.getBillingTypeByCompany(cmp)
          const detailModel = Number(this.config.get('DetailTitleShowModel'))
          const mblMid = detailModel === 0 ? this.formatJobTitleMblSegment(job) : null
          if (detailModel === 0) {
            jobTitle =
              '<span style="margin-right:10px">' +
              jobTitle +
              '</span><span style="margin-right:10px">' +
              mblMid +
              '</span><span style="margin-right:10px">' +
              (this.$store.getters.language === 'zh' ? cmp.chineseName : cmp.englishName) +
              creditTerm +
              '</span><span>' +
              billingType +
              '</span>'
          } else {
            jobTitle = '<span style="margin-right:10px">' + jobTitle + '</span><span style="margin-right:10px">' + (this.$store.getters.language === 'zh' ? cmp.chineseName : cmp.englishName) + creditTerm + '</span><span>' + billingType + '</span>'
          }
        }
      }
      this.commonInfo.jobTitle = jobTitle
    },
    // 检查计提发布状态
    async checkProvisionPublishedStatus() {
      if (!this.job || !this.job.uuid) {
        this.commonInfo.provisionLock = { etdLocked: false, feeLocked: false }
        return
      }

      try {
        const res = await checkJobProvisionFlag(this.job.uuid)
        this.commonInfo.provisionLock = res.ok ? normalizeProvisionLock(res.data) : { etdLocked: false, feeLocked: false }
      } catch (error) {
        console.error('检查计提发布状态失败:', error)
        this.commonInfo.provisionLock = { etdLocked: false, feeLocked: false }
      }
    },
    // 复制
    toCopy() {
      if (this.job.masterFlag) {
        this.$emit('copy', this.job)
      } else {
        if (this.job.customerId) {
          isContractExpiredForbidCreateJob(this.job.customerId).then(res => {
            if (res.data) {
              this.$message.info(this.$t('Message.ContractExpireCannotCreated'))
            } else {
              this.$emit('copy', this.job)
            }
          })
        }
      }
    },
    // 预提交
    doSubmitPrint_PreSubmit() {
      this.doSubmitPrintPROFIT(CheckRuleConstants.NODE_PRE_COMMIT.code)
    },
    // 提交
    doSubmitPrint_Submit() {
      this.doSubmitPrintPROFIT(CheckRuleConstants.NODE_COMMIT.code)
    },
    // 主管提交
    doSubmitPrint_ManagerSubmit() {
      this.doSubmitPrintPROFIT(CheckRuleConstants.NODE_MANAGER_COMMIT.code)
    },
    // 主管审核
    async doSubmitAudit_ManagerSubmit() {
      this.optName = ''
      const job = this.job
      const checkApChargeVerify = parseInt(this.config.get('PreCommitJobCheckApChargeStateVerify'))
      if (checkApChargeVerify === 1) {
        const isPass = await JobUtils.checkChargeStateVerify(this.job)
        if (!isPass) {
          this.$message.warning(this.$t('Message.NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance'))
          return
        }
      }
      // 当整拼类型 为自拼箱时  判断开关是否开启 拒绝提交
      const ticketsMustBeVoted = parseInt(this.config.get('TicketsMustBeVoted'))
      if (!job.masterFlag && !job.lclMasterUuid && (job.containerLoadType === 'LCL' || job.containerLoadType === 'BC') && ticketsMustBeVoted === 1) {
        this.$message.warning(this.$t('Message.TicketsMustBeVoted'))
        return
      }
      const callBack = this.getDoSubmitAudit_ManagerSubmit || null
      const callBack2 = this.getDoSubmitAudit_ManagerSubmit2 || null
      const checkNode = 10
      this.checkingManager(checkNode, callBack, callBack2)
    },
    // 主管审核【验证规则回调函数】
    getDoSubmitAudit_ManagerSubmit() {
      commit(this.job.uuid, SystemConstants.OPERATE_SUBMISSION.code, false, this.office.officeId, this.location).then(async res => {
        await this.mergeCurrentRow(res)
        this.refresh()
      })
    },
    // 主管审核【验证规则回调函数】
    getDoSubmitAudit_ManagerSubmit2() {
      this.commonInfo.showMessage = false
      this.loadChargesPrintReturnHandler()
    },
    // 主管审核【验证规则回调函数】
    async loadChargesPrintReturnHandler() {
      const charges = await new SeaImportJob(this.job).getCharges()
      this.refChargeChargeState(charges)
      this.job.jobState = SystemConstants.OPERATING
      // 撤回置空提交时间
      this.job.submissionDate = null
      this.job.commitUser = 0
      this.job.manageAuditStatus = 0
      this.job.operateNameCode = this.commonInfo.operateNameCode
      this.resetNoNeedSaveData()
      await saveJobInfo(this.job).then(async res => {
        await this.mergeCurrentRow(res)
        this.refresh()
        if (this.commonInfo.showMessage) {
          this.$message.info(this.$t('Message.AlreadyWithdraw'))
        } else {
          this.commonInfo.showMessage = true
        }
      })
    },
    // 保存之前将不需要保存的数据置空,后续需要使用时再加载 this.refresh() 会再走加载那一段
    // 避免循环引用
    resetNoNeedSaveData() {
      if (Object.prototype.hasOwnProperty.call(this.job, 'containerUsages')) {
        for (const usage of this.job.containerUsages) {
          delete usage.container
        }
      }
      if (Object.prototype.hasOwnProperty.call(this.job, 'containers')) {
        for (const container of this.job.containers) {
          delete container.containerUsages
        }
      }
    },
    // node 提交 检测的节点【预提交/提交/主管提交】
    async doSubmitPrintPROFIT(node) {
      this.optName = ''
      const job = this.job
      if (node === CheckRuleConstants.NODE_COMMIT.code || node === CheckRuleConstants.NODE_MANAGER_COMMIT.code) {
        // 预付款余额校验
        const checkFailUuids = []
        const jobKeys = []
        jobKeys.push(job.uuid)
        const continueExec = await JobUtils.checkBalanceBeforeSubmitHandler(jobKeys, checkFailUuids)
        if (!continueExec) {
          return
        }
        // 余额不足
        if (checkFailUuids && checkFailUuids.indexOf(job.uuid) !== -1) {
          return
        }
      }
      this.commonInfo.isPreCommit = node === CheckRuleConstants.NODE_PRE_COMMIT.code
      if (node === CheckRuleConstants.NODE_PRE_COMMIT.code) {
        this.commonInfo.operateNameCode = SystemConstants.OPERATE_PRE_SUBMISSION.code
      } else if (node === CheckRuleConstants.NODE_COMMIT.code) {
        this.commonInfo.operateNameCode = SystemConstants.OPERATE_SUBMISSION.code
      } else if (node === CheckRuleConstants.NODE_MANAGER_COMMIT.code) {
        this.commonInfo.operateNameCode = SystemConstants.OPERATE_MANAGER_SUBMISSION.code
      }

      this.commonInfo.isPrintOpr = false
      const checkApChargeVerify = Number(this.config.get('PreCommitJobCheckApChargeStateVerify'))
      if (this.commonInfo.isPreCommit && checkApChargeVerify === 1) {
        const isPass = await JobUtils.checkChargeStateVerify(this.job)
        if (!isPass) {
          this.$message.warning(this.$t('Message.NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance'))
          return
        }
      }
      // 当整拼类型 为自拼箱时  判断开关是否开启 拒绝提交
      const ticketsMustBeVoted = Number(this.config.get('TicketsMustBeVoted'))
      if (!job.masterFlag && !job.lclMasterUuid && (job.containerLoadType === 'LCL' || job.containerLoadType === 'BC') && ticketsMustBeVoted === 1) {
        this.$message.warning(this.$t('Message.TicketsMustBeVoted'))
        return
      }
      // 判断是否开启验证规则
      const useCheckRule = Number(this.config.get('useCheckRule')) === 1
      const opOffice = this.job.opOffice || 0
      // const hasCheckRule = await JobUtils.hasCheckRuleCondition(useCheckRule, node, opOffice)
      const hasCheckRule = true
      if (useCheckRule && hasCheckRule) {
        const callBack = this.getDoSubmitPrintPROFIT || null
        const callBack2 = this.commitRefuseHandler || null
        const checkNode = node
        this.checkingManager(checkNode, callBack, callBack2)
      } else {
        if (this.commonInfo.allSubmitFcl) {
          await this.doSubmitAllFcl()
          this.refreshLeftTree()
        } else {
          this.doSubmitPrint()
        }
      }
    },
    // 提交【验证规则回调函数】
    async getDoSubmitPrintPROFIT() {
      const job = this.job
      const checkChargeInvoice = Number(this.config.get('CheckReceivableChargePrintInvoice'))
      if (this.commonInfo.isPreCommit || checkChargeInvoice < 1) {
        // CARGO-32805 BPM流程引擎二期，提交
        if (await WorkflowUtil.jobSubmitBpm(this, this.commonInfo.operateNameCode, null, null, this.job)) {
          return
        }
        commit(job.uuid, this.commonInfo.operateNameCode, this.commonInfo.isPreCommit, this.office.officeId, this.location)
          .then(res => {
            if (Number(this.config.get('CommitOpenAutoPushJobToCBMS')) === 1 &&
                    (this.commonInfo.operateNameCode === SystemConstants.OPERATE_SUBMISSION.code ||
                    this.commonInfo.operateNameCode === SystemConstants.OPERATE_MANAGER_SUBMISSION.code)) {
              this.commitCBMSResultHandler(res, '0')
            } else if (this.commonInfo.openHecConfig) {
              this.commitSapResultHandler()
            } else {
              this.commitResultHandler(res)
            }
          })
      } else {
        getChargeIsInvoice(job.uuid).then(res => this.getChargeIsInvoiceResult(res))
      }

      this.refreshLeftTree()
    },

    /**
     * 开启CBMS推送 发送CBMS消息
     * @private
     */
    async commitCBMSResultHandler(res, type = '0') {
      const params = {}
      params.uuid = this.job.uuid
      params.isDisable = type
      params.officeId = this.$store.getters.currentOfficeId
      await sendJobCBMS(params).then(rsp => {
        if (!rsp.data || rsp.data === 'fail') {
          this.$message.error(this.$t('CargoMsg.Cargo_PushFailByCBMS'))
        } else {
          this.$message.success(this.$t('CargoMsg.Cargo_PushSuccessByCBMS'))
        }
        this.commitResult2Handler(res)
      })
    },
    /**
     * 开启sap推送 发送sap消息
     * @private
     */
    async commitSapResultHandler(res) {
      const jobs = []
      jobs.push(this.job.uuid)
      if (this.job.masterFlag && this.job.lclSlaves) {
        for (const j of this.job.lclSlaves) {
          jobs.push(j.uuid)
        }
      }
      const params = {}
      params.jobKey = jobs
      params.oldSapStatus = ChargeUtils.CHARGE_US.code
      params.sapStatus = ChargeUtils.CHARGE_SH.code
      params.needUpdateCharge = true
      params.isSend = false
      await sendHecMessageByJob(params).then(rsp => {
        this.$message.success(this.$t('Message.SapSynchronizationSuccess'))
        this.commitResultHandler(res)
      })
    },
    async backReturnSapResultHandler(res) {
      const jobs = []
      jobs.push(this.job.uuid)
      if (this.job.masterFlag && this.job.lclSlaves) {
        for (const j of this.job.lclSlaves) {
          jobs.push(j.uuid)
        }
      }
      const params = {}
      params.jobKey = jobs
      params.oldSapStatus = 'all'
      params.sapStatus = ChargeUtils.CHARGE_US.code
      params.needUpdateCharge = true
      params.isSend = false
      await backHecMessageByJob(params).then(rsp => {
        this.$message.success(this.$t('Message.SapSynchronizationSuccess'))
        this.commitResult2Handler(res)
      })
    },
    // 提交【验证规则回调函数】
    async commitResultHandler(res) {
      await this.mergeCurrentRow(res)
      this.$message.success(this.$t('Message.CommitSuccessfully'))
      this.refresh()
    },
    async commitResult2Handler(res) {
      await this.mergeCurrentRow(res)
      this.$message.success(this.$t('Message.CommitSuccessfully'))
      this.refresh()
    },
    // 提交主票，小票一起提交
    async doSubmitAllFcl() {
      if (this.job.lclMasterUuid) {
        this.$message.warning(this.$t('Message.LCLTicketCannotBeSubmittedSeparatelyPleaseSubmitTheMBL'))
        return
      } else if (this.job.masterFlag) {
        await this.getLclSlavesAndCharges()
        this.loadSubmitAllFclHandler()
      } else {
        this.doSubmitPrint()
      }
    },
    // 根据主票加载小票以及小票费用
    async getLclSlavesAndCharges() {
      await new SeaImportJob(this.job).getCharges()
      const lclSlaves = await new SeaImportJob(this.job).getLclSlaves()
      if (lclSlaves) {
        for (const lclJob of lclSlaves) {
          if (lclJob.uuid && !lclJob.charges) {
            await new SeaImportJob(lclJob).getCharges()
          }
        }
      }
    },
    // 提交主票
    async loadSubmitAllFclHandler() {
      await RateUtil.refreshChargeRatesByJob(this.job)
      this.job.jobState = this.commonInfo.isPreCommit ? SystemConstants.PRE_COMMIT : SystemConstants.COMMITED
      for (const c of this.job.charges) {
        c.chargeState = BillingConstants.CHARGE_STATE_SUBMIT.code
      }
      for (const lclJob of this.job.lclSlaves) {
        lclJob.jobState = this.commonInfo.isPreCommit ? SystemConstants.PRE_COMMIT : SystemConstants.COMMITED
        if (!this.commonInfo.isPreCommit) {
          for (const c of lclJob.charges) {
            c.chargeState = BillingConstants.CHARGE_STATE_SUBMIT.code
          }
        }
      }
      this.job.operateNameCode = this.commonInfo.operateNameCode
      if (this.job.jobState === SystemConstants.PRE_COMMIT) {
        // 保存job相关信息【saveJobInfo = save2】
        this.resetNoNeedSaveData()
        await saveJobInfo(this.job).then(async res => {
          await this.mergeCurrentRow(res)
          this.$message.success(this.$t('Message.CommitSuccessfully'))
          this.refresh()
        })
      } else {
        // CARGO-32805 BPM流程引擎二期，提交
        if (await WorkflowUtil.jobSubmitBpm(this, this.commonInfo.operateNameCode, null, null, this.job)) {
          return
        }
        // 保存刷新过的的汇率 by Marco 2014-8-8 (Bad Design)
        this.resetNoNeedSaveData()
        await saveJobInfo(this.job).then(async res => {
          await this.mergeCurrentRow(res)
          this.commonInfo.isPrint = false
          if (this.btnInfo.visible.printFclProfit) {
            this.checkPrintEnable(this.doPrintFCLPROFIT)
          } else {
            this.checkPrintEnable(this.doPrintLCLPROFIT)
          }
        })
      }
    },
    // 整箱利润打印提交 isProfitPrint:是否由整箱/拼箱利润打印按钮触发
    async doPrintFCLPROFIT(isProfitPrint = false) {
      // 当是整/拼箱利润打印按钮事件且 PrintProfitToPreCommit=1或2时，先打印再提交
      if (isProfitPrint && [1, 2].includes(Number(this.config.get('PrintProfitToPreCommit')))) {
        this.previewFCLProfit({ data: this.job }, isProfitPrint)
      } else {
        calculateProfit(this.job.uuid, -1, this.commonInfo.isPrintOpr, this.commonInfo.allSubmitFcl, this.commonInfo.isPreCommit, this.office.officeId, '', this.location).then(res => this.previewFCLProfit(res, isProfitPrint))
      }
    },
    // 拼箱利润打印提交
    async doPrintLCLPROFIT(isProfitPrint = false) {
      // 当是整/拼箱利润打印按钮事件且 PrintProfitToPreCommit=1或2时，先打印再提交
      if (isProfitPrint && [1, 2].includes(Number(this.config.get('PrintProfitToPreCommit')))) {
        this.previewLCLProfit({ data: this.job }, isProfitPrint)
      } else {
        calculateProfit(this.job.uuid, -1, this.commonInfo.isPrintOpr, this.commonInfo.allSubmitFcl, this.commonInfo.isPreCommit, this.office.officeId, '', this.location).then(res => this.previewLCLProfit(res, isProfitPrint))
      }
    },
    // 拼箱利润打印预处理
    previewLCLProfit(res, isProfitPrint) {
      this.previewProfit(res, 'LCL', isProfitPrint)
    },
    // 整箱利润打印预处理
    previewFCLProfit(res, isProfitPrint) {
      this.previewProfit(res, 'FCL', isProfitPrint)
    },
    // 预览打印【区分整箱拼箱】
    async previewProfit(res, type, isProfitPrint = false) {
      // 整箱拼箱利润打印按钮事件触发打印弹窗，预提交/提交/主管提交不触发
      if (isProfitPrint) {
        await this.mergeCurrentRow(res)
        this.$nextTick(() => {
          const params = {}
          params.jobuuid = this.job.uuid
          params.showPreview = this.commonInfo.isPrint
          params.JOB_UUID = this.job.uuid
          // 提交之前需要预打印，预打印是不需要弹出提示框的，这里主要是控制PrintTemplateManager.profitSubmitHandler的提示控制
          let category = 'PXLR_SI'
          if (type === 'FCL') {
            params.isCommitJob = this.commonInfo.isPrint
            category = 'SIFCLPROFIT'
          }
          params.isPreCommit = this.commonInfo.isPreCommit
          console.log(type + '-previewProfit--params--', params)
          this.templateSelectorDialog.ctx = new SeaImportJob(this.job)
          this.templateSelectorDialog.category = category
          this.templateSelectorDialog.data = params
          // 组装打印回调函数
          this.prePrintCallback = null
          this.printedCallback = this.doPrintPROFIT
          this.v2CheckCallback = this.doPrintPROFIT_V2
          this.templateSelectorDialog.visible = true
        })
      } else {
        // CARGO-32805 BPM流程引擎二期，提交
        if (await WorkflowUtil.jobSubmitBpm(this, this.commonInfo.operateNameCode, isProfitPrint, this.config, this.job)) {
          return
        }
        // 预提交/提交直接显示已提交，不显示利润打印弹窗
        if (Number(this.config.get('useCheckRule')) === 1) {
          printProfit(this.job.uuid, this.commonInfo.operateNameCode, this.office.officeId, this.optName, this.location).then(res => this.calculateResultHandler(res))
        } else {
          calculateProfit(this.job.uuid, this.commonInfo.operateNameCode, this.commonInfo.isPrintOpr, true, this.commonInfo.isPreCommit, this.office.officeId, this.optName, this.location).then(res => this.calculateResultHandler(res))
        }
      }
      this.updateControlsState()
      this.refresh()
    },
    async calculateResultHandler(res) {
      this.optName = ''
      const oldJobState = this.job.jobState
      await this.mergeCurrentRow(res)
      this.refreshChargeHandler(oldJobState)
      this.refresh()
    },
    // 打印回调函数
    doPrintPROFIT(event) {
      this.commonInfo.printEvent = event
      this.commonInfo.isPreCommit = event.isPreCommit

      if (PrintUtils.isExecutor(event.action)) {
        if (this.job && this.job.uuid) {
          // 检查是否有收费用未开发票
          if (this.job.jobState === SystemConstants.OPERATING) {
            getChargeIsInvoice(this.job.uuid).then(res => this.getChargeIsInvoiceResult(res, true))
          } else {
            this.printAlert(true)
          }
        }
      }
    },
    // 打印回调函数
    doPrintPROFIT_V2(isSure, template, entity, arms) {
      if (isSure && arms) {
        this.commonInfo.isPreCommit = arms.event.isPreCommit
        if (PrintUtils.isExecutor(arms.event.action)) {
          this.printAlert(true)
        }
      }
    },
    // 确认是否可打印
    checkPrintEnable(callback, isProfitPrint = false) {
      if (this.job && !this.job.masterFlag && this.job.sales <= 0 && this.job.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
        const msg = this.commonInfo.isPrint ? this.$message.warning(this.$t('Message.PleaseInputTheSalesInformationAndPrints')) : this.$message.warning(this.$t('Message.PleaseInputTheSalesInformationAndSubmit'))
        this.$message.info(msg)
        return
      }
      const jobNos = this.checkSales()
      if (jobNos.length > 0) {
        const msg1 = this.$t('Message.FollowingTheSingleDidNotEnterTheSalesInformation') + ':\n' + jobNos.join('\n') + '\n' + this.$t('Message.PleaseEnterAndPrint')
        const msg2 = this.$t('Message.FollowingTheSingleDidNotEnterTheSalesInformation') + ':\n' + jobNos.join('\n') + '\n' + this.$t('Message.PleaseEnterAndSubmit')
        this.$message.info(this.commonInfo.isPrint ? msg1 : msg2)
        return
      }
      callback(isProfitPrint)
    },
    // 验证销售及揽货类型
    checkSales() {
      const jobNos = []
      if (!this.job.lclSlaves) {
        for (const j of this.job.lclSlaves) {
          if (j.sales <= 0 && j.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
            jobNos.push(j.jobNo)
          }
        }
      }
      return jobNos
    },
    // 正常提交
    async doSubmitPrint() {
      // CARGO-32805 BPM流程引擎二期，提交
      if (await WorkflowUtil.jobSubmitBpm(this, this.commonInfo.operateNameCode, null, null, this.job)) {
        return
      }
      if (this.job.jobState === SystemConstants.PRE_COMMIT) {
        if (this.job.uuid && !this.job.charges) {
          await new SeaImportJob(this.job).getCharges()
        }
        await this.loadChargeHandler()
        return
      }
      this.commonInfo.isPrint = false
      if (this.btnInfo.visible.printFclProfit) {
        this.checkPrintEnable(this.doPrintFCLPROFIT)
      } else {
        this.checkPrintEnable(this.doPrintLCLPROFIT)
      }
    },
    // 加载当前业务的费用
    async loadChargeHandler() {
      this.job.jobState = SystemConstants.COMMITED
      for (const c of this.job.charges) {
        if (c.chargeState === BillingConstants.CHARGE_STATE_NORMAL.code) {
          c.chargeState = BillingConstants.CHARGE_STATE_SUBMIT.code
        }
        // 刷新汇率
        const localCurrency = RateUtil.localCurrencyByOfficeId(c.branchId)
        c.exchangeRate = await RateUtil.getForeignExchangeRateByJob(localCurrency, c.currency, this.job, c.branchId)
      }
      this.job.operateNameCode = this.commonInfo.operateNameCode
      this.resetNoNeedSaveData()
      this.job.submissionDate = DateUtils.formatStandardDateTime(new Date())
      this.job.commitUser = this.user.userId
      await saveJobInfo(this.job).then(async res => {
        await this.mergeCurrentRow(res)
        this.$message.success(this.$t('Message.CommitSuccessfully'))
        this.refresh()
      })
    },
    // 打印回调函数
    commitRefuseHandler() {
      this.refresh()
      this.refreshLeftTree()
    },
    // 检查是否有收费用未开发票
    async getChargeIsInvoiceResult(res, isProfitPrint = false) {
      const flag = res.data
      if (flag) {
        const msg = this.commonInfo.isPrint ? this.$t('Message.ThereAreFeesReceivableNotInvoicedPrint') : this.$t('Message.ThereAreFeesReceivableNotInvoicedSubmit')
        await this.$confirm(msg, this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(async() => {
          await this.printAlert(isProfitPrint)
        }).catch(() => {
          this.commonInfo.isPrint = true
        })
      } else {
        await this.printAlert(isProfitPrint)
      }
    },
    // 打印提示
    async printAlert(isProfitPrint = false) {
      const printProfitToPreCommit = Number(this.config.get('PrintProfitToPreCommit'))
      if (printProfitToPreCommit === 0 ||
        this.job.jobState === SystemConstants.SHUT_OUT || this.job.jobState === SystemConstants.VERIFIED || this.job.jobState === SystemConstants.COMMITED ||
        (this.job.jobState === SystemConstants.PRE_COMMIT && printProfitToPreCommit === 1)) {
        await this.onConfirmedPrintProfit(isProfitPrint)
      } else {
        let msg = this.$t('Message.VerifyThatTheRelatedFileHasBeenUploadedBeforeSubmittingSystemContinue')
        if (this.commonInfo.isPreCommit) {
          msg = this.$t('Message.SubmittedToTheSuperiorAuditVerifyThatTheRelatedFileHasBeenUploadedBeforeSubmittingSystemContinue')
        }
        await this.$confirm(msg, this.$t('common.tips.warning'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(async() => {
          await this.onConfirmedPrintProfit(isProfitPrint, true)
        }).catch({})
      }
    },
    // 提交/预提交
    async onConfirmedPrintProfit(isProfitPrint = false, isPrint = false) {
      // CARGO-32805 BPM流程引擎二期，提交
      if (await WorkflowUtil.jobSubmitBpm(this, this.commonInfo.operateNameCode, isProfitPrint, this.config, this.job)) {
        return
      }
      // 利润打印 按钮逻辑
      // if (isProfitPrint) {
      //   calculateProfit(this.job.uuid, this.commonInfo.operateNameCode, this.commonInfo.isPrintOpr, true, this.commonInfo.isPreCommit, this.office.officeId).then(res => this.calculateProfit2ResultHandler(res, isProfitPrint, isPrint))
      //   return
      // }
      if (Number(this.config.get('useCheckRule')) === 1) {
        printProfit(this.job.uuid, this.commonInfo.operateNameCode, this.office.officeId, this.optName, this.location).then(res => this.calculateProfit2ResultHandler(res, isProfitPrint, isPrint))
      } else {
        calculateProfit(this.job.uuid, this.commonInfo.operateNameCode, this.commonInfo.isPrintOpr, true, this.commonInfo.isPreCommit, this.office.officeId, this.optName, this.location).then(res => this.calculateProfit2ResultHandler(res, isProfitPrint, isPrint))
      }
    },
    // 提交成功
    async calculateProfit2ResultHandler(res, isProfitPrint = false, isPrint = false) {
      const oldJobState = this.job.jobState
      this.optName = ''
      await this.mergeCurrentRow(res)
      if ((!isProfitPrint || isPrint) && this.commonInfo.printEvent && !PrintUtils.isPrint(this.commonInfo.printEvent.action)) {
        const template = this.commonInfo.printEvent.template
        const parameter = this.commonInfo.printEvent.parameter
        let documentType = null
        if (template && template.documentTypeUuid || !Object.prototype.hasOwnProperty.call(parameter, 'documentType') || !parameter.documentType) {
          await getDocumentType(template.documentTypeUuid).then(res => {
            documentType = res.data ? res.data : null
          })
        }
        if (StimulSoftUtil.isOpenStiReport(template)) {
          parameter.designMode = this.$checkPermission(['role_template_design']) ? 1 : 0
          parameter.documentType = documentType
          await StimulSoftUtil.stiReportPreview(template, this.job, parameter)
        } else {
          const action = this.commonInfo.printEvent.action || ''
          const format = this.commonInfo.printEvent.format || ''
          const url = await PrintTemplateManager.print(template, documentType, format, parameter, action === PrintUtils.PRINT)
          if (url) {
            await this.loadMailURL(url, parameter)
          }
        }
      }
      // 提交成功推送费用
      if (this.commonInfo.operateNameCode === SystemConstants.OPERATE_SUBMISSION.code || this.commonInfo.operateNameCode === SystemConstants.OPERATE_MANAGER_SUBMISSION.code) {
        if (this.commonInfo.openHecConfig) {
          const jobs = []
          jobs.push(this.job.uuid)
          if (this.job.masterFlag && this.job.lclSlaves) {
            for (var j of this.job.lclSlaves) {
              jobs.push(j.uuid)
            }
          }
          const params = {}
          params.jobKey = jobs
          params.oldSapStatus = ChargeUtils.CHARGE_US.code
          params.sapStatus = ChargeUtils.CHARGE_SH.code
          params.needUpdateCharge = true
          params.isSend = false
          await sendHecMessageByJob(params).then(rsp => {
            this.$message.success(this.$t('Message.SapSynchronizationSuccess'))
          })
        }
      }
      this.refreshChargeHandler(oldJobState, isProfitPrint)
      this.refresh()
    },
    // 加载MailURLRequest
    async loadMailURL(url, parameter) {
      let status = -1
      const request = new XMLHttpRequest()
      request.open('GET', url, false) // false 同步，默认异步【此处需要同步，需要拿status判断做后续处理】
      request.onload = function(e) {
        status = e.target.status
      }
      request.onerror = function(e) {
        this.loadError()
      }
      request.send()
      if (Object.prototype.hasOwnProperty.call(parameter, 'showPreview') && parameter.showPreview) {
        this.httpResultEmail(status)
      }
    },
    // Mail异常结果处理
    httpResultEmail(status) {
      // 附件过大
      if (status === 0) {
        this.$message.error('附件内容过大')
      } else if (status === 1) {
        this.$message.error(this.$t('SeaExport.SmtpServerError'))
      } else if (status === 2) {
        this.$message.error(this.$t('SeaExport.NotConnectSmtpServer'))
      } else if (status === 3) {
        this.$message.error(this.$t('SeaExport.NotFindFile'))
      } else if (status === 4) {
        this.$message.error(this.$t('SeaExport.SendFileError'))
      } else if (status === 5) {
        this.$message.error(this.$t('SeaExport.AttachTemplateError'))
      } else if (status === 200) {
        this.$message.success(this.$t('SeaExport.MailSentSuccess'))
      }
    },
    // 刷新Tab
    refreshChargeHandler(oldJobState = -2, isProfitPrint = false) {
      if (!this.commonInfo.isPreCommit) {
        this.refresh()
      }
      this.commonInfo.isPrint = true
      this.commonInfo.isPrintOpr = false
      if (isProfitPrint && oldJobState === SystemConstants.COMMITED) return // 如果是已提交状态再整箱利润打印，就不需要再弹出提交成功提示
      if (isProfitPrint && Number(this.config.get('PrintProfitToPreCommit')) === 0) return // 如果是打印按钮事件 且printProfitToPreCommit=0，不再弹出提交成功提示
      if (isProfitPrint && oldJobState === SystemConstants.PRE_COMMIT) return
      this.$message.success(this.$t('Message.CommitSuccessfully'))
    },
    // 委托
    async entrustmentClickHandler() {
      const company = await Company.getCompanyById(this.job.exChangeAgent)
      if (company && company.linkedBranchId > 0 && company.linkedBranchId !== this.job.opOffice) { // 内部委托
        if (this.btnInfo.label.btnEntrustment === this.$t('SeaExport.Consignation')) {
          if (this.job.relatedJob) {
            this.$message.info(this.$t('Message.TicketEntrustedCannotRepetitionDelegate'))
            return
          }
        }
        this.doSendBranchHandler()
      }
      // else if (company && company.relateTenantId > 0 && company.relateTenantOfficeId > 0) { // 跨tenant委托
      //   this.doCrossTenantHandler()
      // }
    },
    // 委托 发送分公司
    doSendBranchHandler() {
      if (this.btnInfo.label.btnEntrustment === this.$t('SeaExport.AssociationBusinessInformation')) {
        // 查看关联业务信息
        if (this.job.relatedJob.trim().length > 0) {
          getRelatedJobFunc(this.job.relatedJob, 0).then(res => {
            this.queryTrustResultHandler(res)
          })
        } else {
          this.$message.info(this.$t('Message.NoAssociatedBusiness'))
        }
      } else {
        this.checkingConsignationJob()
      }
    },
    // 后端检查该业务是否可以委托
    checkingConsignationJob() {
      checkingConsignationJob(this.job.uuid).then(async res => {
        if (res.data === 1) {
          const company = await Company.getCompanyById(this.job.exChangeAgent)
          if (company) {
            // 检索属于订舱代理所属分公司的合作伙伴ID
            queryCompany(1, this.job.opOffice).then(async res => {
              // 检索属于订舱代理所属分公司的合作伙伴ID
              const companyArr = res.data
              if (companyArr && companyArr.length > 0) {
                this.partner = companyArr[0]
                // 加载联系人
                await new Company(this.partner).getContacts()
                const office = await Office.getOfficeById(company.linkedBranchId)
                if (!office) {
                  return
                }
                this.sendBranchWindow.office = office
                this.sendBranchWindow.title = office.chineseName
                if (!this.sendBranchWindow.checkConsigneeDefault) {
                  this.sendBranchWindow.consigneeTarget = 'consignee'
                  this.sendBranchWindow.consigneeDetailTarget = 'consigneeDetail'
                }
                this.sendBranchWindow.visible = true
              } else {
                this.$message.info(this.$t('Message.TheBranchCompanyOfUnExchangeAgent'))
              }
            })
          }
        } else {
          this.$message.info(this.$t('Message.CheckingConsignation'))
        }
      })
    },
    // 销售change事件
    async userId_changeHandler(item) {
      const userId = item.userId
      if (userId > 0) {
        if (item.selectObject === 0) {
          await getUserDefaultDepartment({ category: 'role', shape: 'csr', userId: userId }).then(res => this.getDefaultCsrResult(res, item))
        } else {
          const office = this.sendBranchWindow.office
          if (office) {
            await getUserDefaultDepartment({ category: 'role', shape: 'op', userId: userId, officeId: office.officeId }).then(res => this.getDefaultDeptResult(res, item))
          } else {
            await getUserDefaultDepartment({ category: 'role', shape: 'op', userId: userId }).then(res => this.getDefaultDeptResult(res, item))
          }
        }
      } else {
        item.departmentId = 0
        item.userId = 0
      }
    },
    // 操作部门
    getDefaultDeptResult(event, item) {
      const dep = event.data
      if (dep) {
        item.departmentId = dep.departmentId
      } else {
        item.departmentId = 0
      }
    },
    // 客服部门
    async getDefaultCsrResult(event, item) {
      const dep = event.data
      if (dep) {
        item.departmentId = dep.departmentId
        if (dep.officeUuid) {
          await getOfficeByUuid(dep.officeUuid).then(res => this.officeLoadHandler(res, item))
        } else {
          this.officeLoadHandler({ data: dep.office }, item)
        }
      } else {
        item.departmentId = 0
        item.departmentOfficeId = 0
      }
    },
    // 加载csr加载dep后加载office后更新业务的客服分公司
    officeLoadHandler(event, item) {
      const office = event.data
      if (office) {
        item.departmentOfficeId = office.officeId
      } else {
        item.departmentOfficeId = 0
      }
    },
    // 内部委托 发送分公司保存业务
    async enterSendHandler() {
      // 复制一票新的业务以及更新当前业务的relatedJob放在后端[返回修改后的job]
      const item = {}
      item.deptId = this.$store.getters.currentDeptId
      item.branchId = this.$store.getters.currentOfficeId
      item.anyStr = this.sendBranchWindow.items[0].selectObject === 0 ? 'csr' : 'op'
      item.anyBool = this.commonInfo.isCopySellingCharge
      item.anyInteger = this.sendBranchWindow.items[0].departmentId
      item.anyInteger1 = this.sendBranchWindow.items[0].departmentOfficeId
      item.anyInteger2 = this.sendBranchWindow.items[0].userId
      item.anyInteger3 = this.partner.cmpIdx
      item.anyInteger4 = this.sendBranchWindow.office.officeId
      item.anyStr1 = this.job.uuid
      if (this.sendBranchWindow.items.length > 1) {
        const item2 = this.sendBranchWindow.items[1]
        item.anyStr2 = item2.selectObject === 0 ? 'csr' : 'op'
        item.anyInteger5 = item2.departmentId
        item.anyInteger6 = item2.departmentOfficeId
        item.anyInteger7 = item2.userId
      }
      if (this.sendBranchSelectObject === 2) {
        if (this.sendBranchWindow.consigneeTarget === 'customer') {
          if (this.job.masterFlag) {
            if (this.job.lclSlaves && this.job.lclSlaves.length > 0) {
              for (const lclSlave of this.job.lclSlaves) {
                const company = lclSlave.consigneeId > 0 ? await Company.getCompanyById(lclSlave.consigneeId) : null
                if (company) {
                  if (!company.customer) {
                    this.$message.warning(`【${lclSlave.jobNo}】` + this.$t('queryJob.ConsigneeCustomerNotExist'))
                    return
                  }
                } else {
                  this.$message.warning(`【${lclSlave.jobNo}】` + this.$t('queryJob.RecipientNotExist'))
                  return
                }
              }
            }
          } else {
            const company = this.job.consigneeId > 0 ? await Company.getCompanyById(this.job.consigneeId) : null
            if (company) {
              if (!company.customer) {
                this.$message.warning(this.$t('queryJob.ConsigneeCustomerNotExist'))
                return
              }
            } else {
              this.$message.warning(this.$t('queryJob.RecipientNotExist'))
              return
            }
          }
        }
        item.consigneeTarget = this.sendBranchWindow.consigneeTarget
        item.consigneeDetailTarget = this.sendBranchWindow.consigneeDetailTarget
      }
      item.location = this.location
      const excludeFileds = []
      for (const item of this.sendBranchWindow.items) {
        if (item.userId) {
          excludeFileds.push(item.selectObject)
        }
      }
      item.checkSalesMapping = this.sendBranchWindow.checkSalesMapping
      if (item.checkSalesMapping) {
        const cloneJob = {
          ...this.job,
          customerId: this.job.bookingAgent,
          designationAgent: 0,
          opOffice: item.anyInteger4,
          sales: 0,
          salesOffice: 0,
          salesDepartment: 0
        }
        await JobUtils.loadSalesByJob(cloneJob, true)
        item.sales = cloneJob.sales
        item.salesOffice = cloneJob.salesOffice
        item.salesDepartment = cloneJob.salesDepartment
      }
      saveCloneJobFunc(item).then(res => {
        if (res.data && res.data.relatedJob) {
          getRelatedJobFunc(res.data.relatedJob, this.$store.getters.tenantId).then(res2 => {
            JobUtils.matchPresetConfigAndSave(res2.data, excludeFileds)
          })
        }
        this.saveCloneResultHandler(res)
      })
      this.sendBranchWindow.visible = false
    },
    async saveCloneResultHandler(res) {
      await this.mergeCurrentRow(res)
      this.$message.success(this.$t('Message.SuccessfullySent'))
      this.btnInfo.label.btnEntrustment = this.$t('SeaExport.AssociationBusinessInformation')
      this.sendBranchWindow.items[0].userId = 0
      this.sendBranchWindow.office = {}
      this.sendBranchWindow.items[0].departmentId = 0
      this.sendBranchWindow.items[0].departmentOfficeId = 0
      this.sendBranchWindow.items[0].selectObject = 0
    },
    async querySEtrustFrom() {
      const company = await Company.getCompanyById(this.job.destinationAgent)
      if (company.linkedBranchId > 0 && company.relateTenantId === 0) { // 查看内部委托出口信息
        getTrustFromJob(this.job.trustFromJob, this.$store.getters.tenantId).then(res => this.queryTrustResultHandler(res))
      } else if (company.relateTenantId && company.linkedBranchId === 0) { // 跨租户委托出口业务信息
        getTrustFromJob(this.job.trustFromJob, company.relateTenantId).then(res => this.queryTrustResultHandler(res))
      }
    },
    async queryTrustResultHandler(event) {
      const trustJob = event.data
      if (trustJob) {
        // 显示关联业务
        this.trustFromWindow.trustJob = trustJob
        this.trustFromWindow.visible = true
      } else {
        this.$message.warning(this.$t('Message.FailedToQueryTheAssociatedBusiness'))
      }
    },
    // 发送跨tenant
    doCrossTenantHandler() {
      this.$confirm(this.$t('Message.MakeSureToDelegateTheBusiness'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        // this.btnInfo.privilege.btnEntrustment = false
        this.sendCrossTenantHandler()
      }).catch(() => { })
    },
    // 发送跨tenant委托
    async sendCrossTenantHandler() {
      const company = await Company.getCompanyById(this.job.bookingAgent)
      if (company) {
        // 检索订舱代理所属分公司在合作伙伴中维护的tenant，是否也维护了当前tenant
        mainTainCurrentTenantCompanies(company.relateTenantId, this.job.opOffice).then(res => this.maitainTenantResult(res))
      }
    },
    async maitainTenantResult(event) {
      const cmps = event.data
      if (cmps && cmps.length > 0) {
        this.partner = cmps[0]
        // 加载联系人
        await new Company(this.partner).getContacts()
        this.loadCrossTenantContractsHandler()
      } else {
        this.$message.info(this.$t('Message.TheReceivingPartyDoesNotMaintainTheCurrentCompanyInformationAmongPartners'))
        // this.$refs.btnEntrustment.disabled = false
      }
    },
    loadCrossTenantContractsHandler() {
      queryLatestState(this.job.jobNo).then(res => this.stateResultHandler(res))
    },
    async stateResultHandler(event) {
      const latestState = event.data
      if (latestState === 3) {
        this.$message.info(this.$t('Message.TheOppositeSideHasScceptedNoNeedToReCommission'))
      } else {
        const company = await Company.getCompanyById(this.job.bookingAgent)
        const carrier = await Company.getCompanyById(this.job.carrierId)
        if (carrier) {
          if (!carrier.scac) {
            // this.btnInfo.privilege.btnEntrustment = true
            this.$message.info(this.$t('Message.CheckCarrier', [carrier.chineseName]))
            return
          } else {
            getCompanyByTenantIdAndBranchIdAndScac(company.relateTenantId, company.relateTenantOfficeId, carrier.scac).then(res => this.hasCompanyResult(res))
          }
        } else {
          // 检验接收方是否维护对应的港口
          const codes = []
          if (this.job.loadingPortCode && !codes.includes(this.job.loadingPortCode)) {
            codes.push(this.job.loadingPortCode)
          }
          if (this.job.destinationPortCode && !codes.includes(this.job.destinationPortCode)) {
            codes.push(this.job.destinationPortCode)
          }
          if (this.job.dischargingPortCode && !codes.includes(this.job.dischargingPortCode)) {
            codes.push(this.job.dischargingPortCode)
          }
          isHavePorts(company.relateTenantId, codes).then(res => this.hasPortsResult(res))
        }
      }
    },
    async hasCompanyResult(event) {
      const hasCarrier = event.data
      const company = await Company.getCompanyById(this.job.bookingAgent)
      if (!hasCarrier) { // bool 判断是否维护对应的船公司
        // this.btnInfo.privilege.btnEntrustment = true
        const sourceCarrier = await Company.getCompanyById(this.job.carrierId)
        this.$message.info(this.$t('Message.CheckCompanyByConsignation').replace('{0}', company.chineseName).replace('{1}', sourceCarrier.chineseName))
        return
      } else {
        // 检验接收方是否维护对应的港口
        const codes = []
        if (this.job.loadingPortCode && !codes.includes(this.job.loadingPortCode)) {
          codes.push(this.job.loadingPortCode)
        }
        if (this.job.destinationPortCode && !codes.includes(this.job.destinationPortCode)) {
          codes.push(this.job.destinationPortCode)
        }
        if (this.job.dischargingPortCode && !codes.includes(this.job.dischargingPortCode)) {
          codes.push(this.job.dischargingPortCode)
        }
        isHavePorts(company.relateTenantId, codes).then(res => this.hasPortsResult(res))
      }
    },
    async hasPortsResult(event) {
      const result = event.data
      const company = await Company.getCompanyById(this.job.bookingAgent)
      if (!result) {
        // 检验接收方是否维护对应的包装
        if (this.job.packing) {
          isHavePacking(company.relateTenantId, this.job.packing).then(res => this.hasPackingResult(res))
        } else {
          this.doSendCrossTenant()
        }
      } else {
        let message = ''
        for (const code of result) {
          const seaport = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', code)
          if (seaport) {
            message = message + seaport.englishName + ','
          }
        }
        if (message) {
          message = message.substring(0, message.length - 1)
        }
        // this.btnInfo.privilege.btnEntrustment = true
        this.$message.info(this.$t('Message.CheckPortsByConsignation').replace('{0}', company.chineseName).replace('{1}', message))
        return
      }
    },
    // 查询是否被拒绝过
    async doSendCrossTenant() {
      const company = await Company.getCompanyById(this.job.bookingAgent)
      if (company) {
        isRejectedBySendJobNo(this.job.jobNo, company.relateTenantId).then(res => this.isRejectResult(res))
      }
    },
    isRejectResult(event) {
      const isReject = event.data
      if (isReject) { // bool 判断是否被拒绝过
        this.$confirm(this.$t('Message.ElectronicEntrustmentHasBeenSentForThisBusinessSendAgain'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          // 查询pdf模板
          queryTemplateByNameAndType('BOOKING', this.$t('SeaExport.SeaExportLetter'), this.$store.getters.tenantId, this.office.officeId).then(res => this.templateSenderResultHandler(res))
        }).catch(() => { })
      } else {
        // 查询pdf模板
        queryTemplateByNameAndType('BOOKING', this.$t('SeaExport.SeaExportLetter'), this.$store.getters.tenantId, this.office.officeId).then(res => this.templateSenderResultHandler(res))
      }
    },
    async templateSenderResultHandler(event) {
      this.template = event.data
      const company = await Company.getCompanyById(this.job.bookingAgent)
      if (!this.template) {
        this.$confirm(this.$t('Message.DidNotFindTheCorrespondingTemplateTypeBOOKINGAndTemplateNameOceanExportBookingContinueToAuthorize'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          isCrossed(this.job.jobNo, company.relateTenantId).then(res => this.isCrossedHandler(res))
        }).catch(() => {
          // this.btnInfo.privilege.btnEntrustment = true
        })
      } else {
        isCrossed(this.job.jobNo, company.relateTenantId).then(res => this.isCrossedHandler(res))
      }
    },
    isCrossedHandler(event) {
      const isCrossed = event.data
      this.enterSendCrossTenantHandler(isCrossed)
    },
    // isCrossed为false就说明没有委托过当前的订舱代理
    enterSendCrossTenantHandler(isCrossed) {
      const item = {}
      item.deptId = this.$store.getters.currentDeptId
      item.branchId = this.$store.getters.currentOfficeId
      item.anyStr = this.job.uuid
      item.anyBool = isCrossed
      item.anyBool1 = this.commonInfo.isCopySellingCharge // isCopySellingCharge
      item.anyInteger = this.partner.cmpIdx // cmpIdx
      item.location = this.location
      crossTenantJob(item).then(res => this.saveCrossTenantCloneResultHandler(res))
      if (this.sendBranchWindow.visible) {
        this.sendBranchWindow.visible = false
      }
    },
    async saveCrossTenantCloneResultHandler(res) {
      await this.mergeCurrentRow(res)
      this.$message.success(this.$t('Message.SuccessfullySent'))
      // this.btnInfo.privilege.btnEntrustment = true
      this.uploadCloudBasedTemplate()
    },
    async uploadCloudBasedTemplate() {
      if (this.template) {
        const company = await Company.getCompanyById(this.job.bookingAgent)
        const params = {}
        params.JOB_UUID = this.job.uuid
        params.jobuuid = this.job.uuid

        params.relatedJobUUID = this.job.relatedJobUuid
        params.relatedTenantId = company ? company.relateTenantId : ''
        params.relatedJobNo = this.job.relatedJob
        params.showPreview = true
        params.classNameType = SystemConstants.BOOKING
        params.className = 'SeaImportJob' // 后端ReportService会用到此属性
        //
        let documentType = null
        if (this.template && this.template.documentTypeUuid) {
          await getDocumentType(this.template.documentTypeUuid).then(res => {
            documentType = res.data ? res.data : null
          })
        }
        const url = await PrintTemplateManager.print(this.template, documentType, PrintTemplateManager.FORMAT_PDF, params, true)
        if (url) {
          await this.loadMailURL(url, params)
        }
      }
    },
    async hasPackingResult(event) {
      const hasPacking = event.data
      if (!hasPacking) { // bool 判断是否有包装
        // this.btnInfo.privilege.btnEntrustment = true
        const company = await Company.getCompanyById(this.job.bookingAgent)
        const packing = getObjectByCache(basicCacheKeys.basic_data_Packing, 'code', this.job.packing)
        if (company && packing) {
          this.$message.info(this.$t('Message.CheckPackingByConsignation').replace('{0}', company.chineseName).replace('{1}', packing.name))
        }
        return
      } else {
        this.doSendCrossTenant()
      }
    },
    // 日志记录
    logHandle() {
      if (!this.job || !this.job.uuid) {
        return
      }
      switch (this.logCommand) {
        case this.$t('SeaExport.QueryContainerInfo'):
          this.queryPackingInfo()
          break
        case this.$t('CargoMsg.Cargo_BusinessStatusChangeLog'):
          this.businessStatusDialog.visible = true
          break
        case this.$t('SeaExport.ChangeHistory'):
          this.crossTenantDialog.visible = true
          this.crossTenantDialog.readState = false
          break
        case this.$t('SeaExport.OperationLog'):
          this.dataUpdateLogDialog.visible = true
          this.dataUpdateLogDialog.isNeedExpand = true
          this.dataUpdateLogDialog.defaultIsExpand = true
          LocalStorageUtilsNew.setConfiguration('SIDataUpdateLogDialogVisible', true)
          break
      }
    },
    // 装箱信息查询
    queryPackingInfo() {
      let url
      if (this.job && this.job.loadingPortCode === 'CNSHA') {
        if (this.job.mbl) {
          url = 'http://edi.easipass.com/dataportal/query.do?ctno=&blno=' + this.job.mbl + '&pagesize=30&qn=dp_cst_vsl&qid=402803af0ecb1a4c010ecb1bb471004a'
        } else if (this.job.containers && this.job.containers.length > 0) {
          url = 'http://edi.easipass.com/dataportal/query.do?ctno=' + this.job.containers[0].containerNo + '&blno=&pagesize=30&qn=dp_cst_vsl&qid=402803af0ecb1a4c010ecb1bb471004a'
        } else {
          url = 'http://edi.easipass.com/dataportal/query.do?pagesize=30&qn=dp_cst_vsl&qid=402803af0ecb1a4c010ecb1bb471004a'
        }
      } else {
        url = 'http://www.igenzong.com/api2/show?st=Y11'
      }
      this.navigateToURL(url)
    },
    async toQueryDataPushLog() {
      this.context.loading = true
      await new SeaImportJob(this.job).loadPushHistoryLogs()
      this.context.loading = false
      const item = this.job.pushHistoryLogs
      this.dataPushDialog.titles = []
      this.dataPushDialog.dataMap = new Map()
      if (item) {
        const dataArr = []
        for (const k in item) {
          dataArr.push({ 'time': k, 'logs': item[k] })
        }
        // 排序 按时间降序
        sortByMultiField(dataArr, ['time'], true)
        if (dataArr && dataArr.length > 0) {
          for (const data of dataArr) {
            const logs = data.logs
            const firstLog = logs[0]
            let t = '：' + this.$t('SeaExport.DataPush')
            if (Number(firstLog.sourceType) === 1) {
              t = '：' + this.$t('SeaExport.MasterTicketSync')
            } else if (Number(firstLog.sourceType) === 2) {
              t = '：G7' + this.$t('SeaExport.DataPush')
            }
            const labTime = new Date(Number(data.time))
            const title = DateUtils.formatStandardDateTime(labTime) + t
            this.dataPushDialog.titles.push(title)
            const cMap = {}
            let labLog = ''
            const titleVals = []
            for (const h of logs) {
              if (!cMap.hasOwnProperty(h.fieldName + h.targetValue)) {
                if (!h.sourceValue || h.targetValue === h.sourceValue) {
                  labLog = h.fieldName + '：' + this.$t('CargoMsg.Cargo_NewValue') + '->' + h.targetValue
                } else {
                  //
                  const newValArr = h.targetValue ? h.targetValue.split(' ') : []
                  labLog = h.fieldName + '：' + this.$('CargoMsg.Cargo_OriginalValue') + '->' + h.sourceValue + ' ' + this.$t('CargoMsg.Cargo_NewValue') + '->' + (newValArr && newValArr.length > 0 ? newValArr[0] : '')
                  if (newValArr && newValArr.length > 0) {
                    for (const str of newValArr) {
                      const index = newValArr.indexOf(str)
                      if (index > 0) titleVals.push(str)
                    }
                  }
                }
                // 每一行便是一个div[ labLog -> div]
                titleVals.push(labLog)
              }
              if (h.fieldName === '箱种' || h.fieldName === this.$t('SeaExport.ContainerSize')) {
                cMap[h.fieldName + h.targetValue] = h.fieldName + h.targetValue
              }
            }
            this.dataPushDialog.dataMap.set(title, titleVals)
          }
        }
      }
      this.dataPushDialog.visible = true
    },
    againLookAtMultiple() {
      this.currentRow = this.rowData.find(p => p.jobNo === this.$route.query.key)
      this.againShow('look')
    },
    goBackAtMultiple() {
      this.currentRow = this.rowData.find(p => p.jobNo === this.$route.query.key)
      this.againShow('look')
      this.goBack()
    },
    goBack() {
      this.visible = false
      this.$emit('back')
    },
    revertBtnGroupStyle() {
      this.btnGroupLook.style.display = this.action === 'look' ? '' : 'none'
      this.btnGroupNew.style.display = this.isNew ? '' : 'none'
      this.btnGroupEdit.style.display = this.action === 'edit' ? '' : 'none'
    },
    // 打印
    onPrint() {
      if (JobUtils.isBlockJob(this.job)) {
        this.$message.info(this.job.jobNo + '已被锁定,不能打印,请联系上级主管解锁!')
        return
      }
      this.$nextTick(async() => {
        let params
        // 费用页签特殊弹窗回调打印处理
        if (this.activeTabName === 'tabCharges' && this.tabChargesPrintData) {
          params = this.tabChargesPrintData
          this.tabChargesPrintData = null
        }
        // 每个页签的参数
        params = params || await this.$refs[this.activeTabName].getPrintData() || null
        if (!params) return
        // 公共参数
        if (!Object.prototype.hasOwnProperty.call(params, 'jobuuid') || !params.jobuuid) {
          params.jobuuid = this.job.uuid
        }
        if (!Object.prototype.hasOwnProperty.call(params, 'JOB_UUID') || !params.JOB_UUID) {
          params.JOB_UUID = this.job.uuid
        }
        console.log('---params--', params)
        this.templateSelectorDialog.ctx = Object.prototype.hasOwnProperty.call(params, 'ctx') ? params.ctx : null
        if (Object.prototype.hasOwnProperty(params, 'ctx')) delete params.ctx
        this.templateSelectorDialog.category = params.category
        this.templateSelectorDialog.data = params
        // 组装打印回调函数
        await this.onPrintCallback(params)
        this.templateSelectorDialog.visible = true
      })
    },
    // 费用页签 多个结算公司选中单个后的打印回调
    tabChargesPrintDataCallBack(data) {
      if (data) {
        this.tabChargesPrintData = data
        this.onPrint()
      }
    },
    // 组装打印回调函数 优先取 params 里面的回调，再取页签中的回调，这样修改是为了满足国外账单的特殊情况
    onPrintCallback(params) {
      if (Object.prototype.hasOwnProperty.call(params, 'prePrintCallback')) {
        this.prePrintCallback = params.prePrintCallback
        delete params.prePrintCallback
      } else {
        this.prePrintCallback = this.$refs[this.activeTabName].prePrintCallback || null
      }
      if (Object.prototype.hasOwnProperty.call(params, 'printedCallback')) {
        this.printedCallback = params.printedCallback
        delete params.printedCallback
      } else {
        this.printedCallback = this.$refs[this.activeTabName].printedCallback || null
      }
      if (Object.prototype.hasOwnProperty.call(params, 'v2CheckCallback')) {
        this.v2CheckCallback = params.v2CheckCallback
        delete params.v2CheckCallback
      } else {
        this.v2CheckCallback = this.$refs[this.activeTabName].v2CheckCallback || null
      }
    },
    // 整箱利润打印
    async printFCLPROFIT() {
      this.optName = '整箱利润打印'
      this.commonInfo.isPrint = true
      this.commonInfo.isPrintOpr = true
      this.commonInfo.isPreCommit = Number(this.config.get('PrintProfitToPreCommit')) === 1
      // 判断是否开启验证规则
      const useCheckRule = Number(this.config.get('useCheckRule')) === 1
      const checkNode = CheckRuleConstants.NODE_PRINT_PROFIT.code
      const opOffice = this.job.opOffice || 0
      // const hasCheckRule = await JobUtils.hasCheckRuleCondition(useCheckRule, checkNode, opOffice)
      const hasCheckRule = true
      if (useCheckRule && hasCheckRule) {
        const callBack = async() => { this.checkPrintEnable(this.doPrintFCLPROFIT, true) }
        this.checkingManager(checkNode, callBack, null)
      } else {
        this.checkPrintEnable(this.doPrintFCLPROFIT, true)
      }
    },
    // 拼箱利润打印
    async printLCLPROFIT() {
      this.optName = '拼箱利润打印'
      this.commonInfo.isPrint = true
      this.commonInfo.isPrintOpr = true
      // 打印利润分析表后是否变更业务状态 0:不变更，1:变为预提交，2:变为已提交
      this.commonInfo.isPreCommit = Number(this.config.get('PrintProfitToPreCommit')) === 1
      // 判断是否开启验证规则
      const useCheckRule = Number(this.config.get('useCheckRule')) === 1
      const checkNode = CheckRuleConstants.NODE_PRINT_PROFIT.code
      const opOffice = this.job.opOffice || 0
      // const hasCheckRule = await JobUtils.hasCheckRuleCondition(useCheckRule, checkNode, opOffice)
      const hasCheckRule = true
      if (useCheckRule && hasCheckRule) {
        const callBack = async() => { this.checkPrintEnable(this.doPrintLCLPROFIT, true) }
        this.checkingManager(checkNode, callBack, null)
      } else {
        const checkApChargeVerify = Number(this.config.get('PreCommitJobCheckApChargeStateVerify'))
        if (this.commonInfo.isPreCommit && checkApChargeVerify === 1) {
          const isPass = await JobUtils.checkChargeStateVerify(this.job)
          if (!isPass) {
            this.$message.warning(this.$t('Message.NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance'))
            return
          }
        }
        this.checkPrintEnable(this.doPrintLCLPROFIT, true)
      }
    },
    getPrePrintFCLProfit() {
      prePrintProfit(this.job.uuid, this.office.officeId).then(res => this.prePintProfitFCLResultHandler(res))
    },
    getPrePrintLCLProfit() {
      prePrintProfit(this.job.uuid, this.office.officeId).then(res => this.prePintProfitLCLResultHandler(res))
    },
    prePintProfitLCLResultHandler(res) {
      this.prePintProfit(res, 'LCL')
    },
    prePintProfitFCLResultHandler(res) {
      this.prePintProfit(res, 'FCL')
    },
    // 利润打印【区分整箱拼箱】
    async prePintProfit(res, type) {
      await this.mergeCurrentRow(res)
      // TemplateSelectorWin.getInstance().showThisWin(this.job, 'LCLPROFIT', params, this, null, this.preprintProfitCallBack, this.doPrintPROFIT_V2)
      // TemplateSelectorWin.getInstance().showThisWin(this.job, 'FCLPROFIT', params, this, null, this.preprintProfitCallBack, this.doPrintPROFIT_V2)
      this.$nextTick(() => {
        const params = {}
        params.jobuuid = this.job.uuid
        params.showPreview = this.commonInfo.isPrint
        params.JOB_UUID = this.job.uuid
        console.log(type + '-prePintProfit--params--', params)
        this.templateSelectorDialog.ctx = new SeaImportJob(this.job)
        this.templateSelectorDialog.category = !this.job.masterFlag && type !== 'LCL' ? 'SIFCLPROFIT' : 'PXLR_SI'
        this.templateSelectorDialog.data = params
        // 组装打印回调函数
        this.prePrintCallback = null
        this.printedCallback = this.prePrintProfitCallBack
        this.v2CheckCallback = this.doPrintPROFIT_V2
        this.templateSelectorDialog.visible = true
      })
      this.updateControlsState()
      this.refresh()
    },
    prePrintProfitCallBack(event) {
      this.commonInfo.printEvent = event
      this.commonInfo.isPrintCommit = event.isPreCommit
      if (PrintUtils.isExecutor(event.action) && this.job && this.job.uuid) {
        this.printAlert()
      }
    },
    refChargeChargeState(charges) {
      const submitChargeState = parseInt(this.config.get('CommitJobChangedChargeState'))
      if (submitChargeState === 1 && charges && charges.length > 0) {
        for (const c of charges) {
          if (c.chargeState === BillingConstants.CHARGE_STATE_SUBMIT.code) {
            c.chargeState = BillingConstants.CHARGE_STATE_NORMAL.code
          }
        }
      }
    },
    // 合并当前job【刷新当前job】
    async mergeCurrentRow(res) {
      if (res && res.data) {
        Object.assign(this.currentRow, res.data)
        this.currentRow.uuid = res.data.uuid
        if (this.currentRow.masterFlag) {
          this.currentRow.lclSlaves = ''
          await new SeaImportJob(this.currentRow).getLclSlaves()
        }
        this.currentRow.isCompleteRow = false
        this.saveJobNos.push(this.currentRow)
        this.isRefresh = true
      }
    },
    // 退回操作,撤回
    async backReturn() {
      if (this.job.jobState === SystemConstants.COMMITED || this.job.jobState === SystemConstants.PRE_COMMIT) {
        this.commonInfo.operateNameCode = SystemConstants.OPERATE_PRINT_RETURN.code
        let lb = this.$t('Message.Withdraw')
        if (this.job.jobState === SystemConstants.PRE_COMMIT) {
          this.commonInfo.operateNameCode = SystemConstants.OPERATE_RETURN_ACTION.code
          lb = this.$t('Message.ReturnAction')
        }
        const operate = this.job.jobState === SystemConstants.PRE_COMMIT ? SystemConstants.OPERATE_RETURN_ACTION.code : SystemConstants.OPERATE_PRINT_RETURN.code
        if (!await JobUtils.backCheckJobState([this.job.uuid], operate, this.job)) {
          this.refresh()
          return
        }
        this.$confirm(this.$t('Message.IsConfirm') + lb + '?', this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(async() => {
          this.loading = getLoading()
          backReturn({ jobUuids: [this.job.uuid], lob: 'SI', location: this.location }).then(async res => {
            this.loading.close()
            if (Number(this.config.get('CommitOpenAutoPushJobToCBMS')) === 1 &&
                    this.commonInfo.operateNameCode === SystemConstants.OPERATE_PRINT_RETURN.code) {
              await this.commitCBMSResultHandler(res, '1')
            } else if (this.commonInfo.openHecConfig) {
              this.backReturnSapResultHandler(res)
            } else {
              await this.mergeCurrentRow(res)
              this.refresh()
            }
            if (this.currentRow.masterFlag) {
              this.currentRow.lclSlaves = ''
              await new SeaImportJob(this.currentRow).getLclSlaves()
            }
            this.refreshLeftTree()
            this.$message.success(this.$t('Message.AlreadyWithdraw'))
          }).finally(() => {
            this.loading.close()
          })
          // await this.onConfirmedPrintReturn()
        }).catch(() => { })
      }
    },
    onConfirmedPrintReturn() {
      if (this.job.containerLoadType === ContainerLoadType.LCL_CARGO_TYPE.code) {
        this.loadLclSlavesHandler()
      } else {
        this.loadChargesPrintReturnHandler()
      }
    },
    async loadLclSlavesHandler() {
      await new SeaImportJob(this.job).getCharges()
      const lclSlaves = await new SeaImportJob(this.job).getLclSlaves()
      if (lclSlaves) {
        for (const sej of lclSlaves) {
          if (sej.jobState === SystemConstants.COMMITED || sej.jobState === SystemConstants.PRE_COMMIT) {
            await new SeaImportJob(sej).getCharges()
          }
        }
      }
      this.loadJobsChargesPrintReturnHandler()
    },
    async loadJobsChargesPrintReturnHandler() {
      this.job.jobState = SystemConstants.OPERATING
      // 撤回置空提交时间
      this.job.submissionDate = null
      this.job.commitUser = 0
      this.refChargeChargeState(this.job.charges)
      for (const sej of this.job.lclSlaves) {
        if (sej.jobState === SystemConstants.COMMITED || sej.jobState === SystemConstants.PRE_COMMIT) {
          this.refChargeChargeState(sej.charges)
        }
        sej.jobState = SystemConstants.OPERATING
        // 撤回置空提交时间
        sej.submissionDate = null
        sej.commitUser = 0
        sej.operateNameCode = this.commonInfo.operateNameCode
      }
      this.job.operateNameCode = this.commonInfo.operateNameCode
      this.resetNoNeedSaveData()
      await saveJobInfo(this.job).then(async res => {
        await this.mergeCurrentRow(res)
        this.refresh()
        this.$message.success(this.$t('Message.AlreadyWithdraw'))
      })
    },
    // 提交改单费用
    changeCommit_clickHandler() {
      this.$confirm(this.$t('SeaExport.ConfirmChangeCommit'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        updateChangeState(Array.of(this.job.uuid), { changeState: SystemConstants.CHANGE_COMMIT.code, location: this.location }).then(res => this.updateChangeStateHandler(res))
      }).catch(() => { })
    },
    updateChangeStateHandler(res) {
      this.commitResultHandler({ data: res.data[0] })
    },
    // 发送订舱数据
    sendBookingData() {
      feedbackBookingData(this.job).then(res => this.feedbackBookingDataHandler(res))
    },
    feedbackBookingDataHandler(res) {
      const result = res.data
      //  受理成功
      if (result.code === '1') {
        this.$message.success(this.$t('SeaExport.BookingDataSentSuccess'))
      } else if (result.code === '101') {
        this.$message.info(result.msg)
      } else {
        this.$message.error(this.$t('SeaExport.BookingDataSentSuccess'))
      }
    },
    // 根据对象的属性排序[descending 是否降序]
    createComparisonFunction(propertyName, descending = false) {
      return function(object1, object2) {
        const value1 = object1[propertyName]
        const value2 = object2[propertyName]

        if (!descending) {
          return value1 - value2
        } else {
          return value2 - value1
        }
      }
    },
    // 验证规则配置公用
    async checkingManager(checkNode, callBack, callBack2) {
      this.$logger.log('this.job', this.job)
      if (!this.job) return
      let checkType = true
      const callBackFunc = callBack ? () => { callBack() } : null
      const callBack2Func = callBack2 ? () => { callBack2() } : null
      if (this.job.masterFlag && checkNode !== CheckRuleConstants.NODE_SAVE_BUSINESS.code) {
        checkType = false
        this.batchCheckingWindow.checkNode = checkNode
        this.batchCheckingWindow.callBack = callBackFunc
        this.batchCheckingWindow.callBack2 = callBack2Func

        const lclSlaves = await new SeaImportJob(this.job).getLclSlaves()
        if (lclSlaves && lclSlaves.length > 0) { // 批量验证
          this.batchCheckingWindow.jobs = [this.job, ... lclSlaves]
        } else {
          this.batchCheckingWindow.jobs = [this.job]
        }
        this.batchCheckingWindow.visible = true
      }
      if (checkType) { // 单个验证
        this.checkingWindow.checkNode = checkNode
        this.checkingWindow.callBack = callBackFunc
        this.checkingWindow.callBack2 = callBack2Func
        this.checkingWindow.visible = true
      }
    },
    addBatchLcl(lclJob) {
      lclJob.path = ''
      console.log(lclJob)
      this.onShow('add', this.rowData, lclJob)
    },
    transferTargetRow(action, jobUuid) {
      const selectedRow = this.rowData.find(p => p.uuid === jobUuid)
      if (selectedRow) {
        if (this.viewJobNoSet.has(selectedRow.jobNo)) {
          this.$router.push({ name: 'SiBooking', query: { openNew: true, key: selectedRow.jobNo }, params: { action }})
        } else {
          this.onShow(action, this.rowData, selectedRow)
        }
      }
    },
    addSlavedJob(jobs) {
      for (const job of jobs) {
        // 更新 存在于左侧list加入的job
        const findLeftJob = this.rowData.find(p => p.uuid === job.uuid)
        if (findLeftJob) {
          findLeftJob.parentUuid = job.lclMasterUuid
          findLeftJob.path = job.lclMasterUuid + ',' + job.uuid
          findLeftJob.dataType = 2 // 小票
        } else {
          job.jobUuid = job.uuid
          job.parentUuid = job.lclMasterUuid
          job.path = job.lclMasterUuid + ',' + job.uuid
          job.dataType = 2 // 小票
          this.rowData.push(job)
        }
      }
      this.saveJobNos.push(this.currentRow)
      this.saveJobNos.push(...jobs)
      for (let i = this.removedJobNos.length - 1; i >= 0; --i) {
        if (jobs.findIndex(p => p.uuid === this.removedJobNos[i].uuid) >= 0) {
          this.removedJobNos.splice(i, 1)
        }
      }

      this.gridApi.refreshCells({ force: true })

      // 当前主票的件重尺也需要更新 重新加载
      this.currentRow.isCompleteRow = false
      this.currentRow.version = 0
      // 重置子表数据
      for (const key in this.currentRow) {
        if (typeof this.currentRow[key] === 'object') {
          this.currentRow[key] = ''
        }
      }
      this.againShow('look')
    },
    removeJobFromMaster(jobKeys, source) {
      const rows = this.rowData.filter(p => !jobKeys.includes(p.uuid))
      const removedRows = this.rowData.filter(p => jobKeys.includes(p.uuid))
      for (const row of rows) {
        if (source === 'tabLclContainer') {
          row.lclMasterUuid = ''
          row.mbl = ''
          // row.parentUuid = ''
          // row.path = row.uuid
        }
        row.isCompleteRow = false
      }
      this.rowData = [...rows]
      this.saveJobNos.push(this.currentRow)
      this.removedJobNos.push(...removedRows)

      // 当前主票的件重尺也需要更新 重新加载
      this.currentRow.isCompleteRow = false
      this.currentRow.version = 0
      // 重置子表数据
      for (const key in this.currentRow) {
        if (typeof this.currentRow[key] === 'object') {
          this.currentRow[key] = ''
        }
      }
      this.againShow('look')
    },
    removeJob(jobUuid) {
      this.saveJobNos.push(this.currentRow)
      const index = this.rowData.findIndex(p => p.uuid === jobUuid)
      if (index > -1) {
        this.rowData.splice(index, 1)
        this.removedJobNos.push(this.rowData[index])
      }
    },
    splitHandle(row) {
      this.view = 'detail'
      this.onShow('split', this.rowData, row)
    },
    // form表单请求方法
    navigateToURL(URL, PARAMS) {
      const form = document.createElement('form')
      form.action = URL
      form.method = 'post'
      form.style.display = 'none'
      for (const key in PARAMS) {
        const opt = document.createElement('textarea')
        opt.name = key
        opt.value = PARAMS[key]
        form.appendChild(opt)
      }
      form.target = '_blank'
      document.body.appendChild(form)
      form.submit()
    },
    resetTab(tabName) {
      this.pendTabSet.delete(tabName)
    },
    syncData(data) {
      Object.assign(this.currentRow, data)
    },
    addHandler() {
      this.$emit('add')
    },
    async updateJob() {
      const data = {}
      for (const key in this.paramsOfTab) {
        if (typeof this.paramsOfTab[key] === 'object') {
          continue
        }
        data[key] = this.paramsOfTab[key]
      }
      const loading = getLoading4Cxt(this)
      const res = await saveJobInfo(data).finally(() => {
        loading.close()
      })
      await this.mergeCurrentRow(res)
      this.refresh()
    },
    syncTrustFromJob() {
      syncTrustFromJob(this.job.uuid).then(res => {
        this.$message.info(this.$t('Message.SynchronizationSucceeded'))
      })
    },
    checkCrossTenantSEToSI() {
      const company = this.context.companyList.find(p => p.cmpIdx === this.job.destinationAgent)
      if (company && this.job.trustFromJob && company.relateTenantId > 0 && company.relateTenantOfficeId > 0) {
        this.isCrossTenantSEToSI = true
      }
    },
    loadCrossTenantSyncHistory() {
      const jobKey = this.currentRow.uuid
      if (!jobKey) {
        return
      }
      queryCrossTenantSyncHistory({ jobKey: jobKey }).then(res => {
        this.crossTenantDialog.readState = false
        // 判断已读状态
        if (res.data && res.data.length > 0) {
          for (const data of res.data) {
            if (data.receiveJobUuid === jobKey && !data.readState) {
              this.crossTenantDialog.readState = true
              break
            }
          }
        }
        this.crossTenantDialog.data = res.data
      })
    },
    async continueSaving(body, loading, closingLoading = false) {
      try {
        if (closingLoading) {
          loading = getLoading4Cxt(this)
        }
        // saveMasterSeaImportJob 同步主票小票信息 此步移至后端保存处理

        // 保存 访问数据库
        // 拆分主票 保存处理逻辑【也走这里】
        const oldBusinessDate = this.currentRow.eta
        const businessDate = this.paramsOfTab.eta
        const charges = this.paramsOfTab.charges
        if (body && body.job && body.job.masterFlag) {
          body.job.paymentTermHBL = ''
          body.job.freightTermHBL = ''
        }
        body.location = this.location
        body.receiptCharges = this.context.receiptCharges
        let blockCreditData = null
        await this.saveSeaBookingSpaceFunc(body).then(res => {
          const result = res.data.job
          if (result) {
            Object.assign(this.currentRow, result)
            this.currentRow.uuid = result.uuid
            this.currentRow.jobUuid = this.currentRow.uuid
            this.currentRow.dataType = result.masterFlag ? 1 : 2
            body.job.uuid = this.currentRow.jobUuid // syncLclSlaveJobInfo 方法中用到了
            this.currentRow.version = 0 // 标识为脏数据，需要重新载入
            if (this.currentRow.lclMasterUuid) {
              if (this.openMultiple && !this.rowData.some(p => p.uuid === this.currentRow.lclMasterUuid)) {
                this.currentRow.path = result.uuid
              } else {
                this.currentRow.path = result.lclMasterUuid + ',' + result.uuid
              }
            } else {
              this.currentRow.path = result.uuid
            }
            this.isRefresh = true
            this.saveJobNos.push(this.currentRow)
          }
          // 重置子表数据
          for (const key in this.currentRow) {
            if (typeof this.currentRow[key] === 'object') {
              this.currentRow[key] = ''
            }
          }
          this.currentRow.isCompleteRow = false
          blockCreditData = res.data.blockCreditData
        })

        this.refreshLeftTree()

        // 复制多份业务 保存的处理逻辑
        if (this.copyJobNum > 1 && this.currentRow.uuid) {
          await this.saveCopyJobHandle(this.currentRow.uuid, this.currentRow.masterFlag, this.copyJobNum - 1)
        }

        // 主票页签新增多个小票，保存的处理逻辑(海进之后新增一个小票)
        if (this.currentRow.lclNumber && this.currentRow.uuid) {
          const job = this.currentRow
          // 更新新增的第一条小票数据
          await new SeaImportJob(job).loadJobRelated({ job: true })
          job.jobUuid = job.uuid
          job.parentUuid = job.lclMasterUuid
          job.path = job.lclMasterUuid + ',' + job.uuid
          job.dateType = 2 // 小票
          if (job.lclNumber > 1) {
            await this.saveLclJob(job.uuid, job.lclNumber - 1)
          } else {
            this.rowData = [...this.rowData.filter(jb => jb.uuid !== job.uuid), { ...job, lclNumber: null }]
          }
          delete job.lclNumber
          // 切换回主票
          this.currentRow = this.rowData.find(p => p.uuid === job.lclMasterUuid)
          this.currentRow.version = 0
          // 重置子表数据【将job相关信息置空，然后从库里重新加载】
          for (const key in this.currentRow) {
            if (typeof this.currentRow[key] === 'object') {
              this.currentRow[key] = ''
            }
          }
        }
        for (const item of this.pendTabSet) {
          const executeTask = this.$refs[item].executeTask
          if (executeTask && typeof executeTask === 'function') {
            /* 保存成功后的回调 */
            const result = this.$refs[item].executeTask()
            if (result instanceof Promise) {
              await result
            }
          }
        }
        if (this.openMultiple) {
          if (this.currentRow.jobNo !== this.$route.query.key) {
            const rowData = deepCopy(this.rowData)
            this.reset(rowData)
            this.$message.success(this.$t('Message.SaveSuccessfully'))
            this.$router.push({ name: 'SiBooking', query: { openNew: true, key: this.currentRow.jobNo }, params: { rowData, replace: true }})
            return
          }
          await this.againShow('look', this.currentRow)
        } else {
          this.againShow('look', this.currentRow)
          /*          if (this.currentRow.jobState === 0 && businessDate !== oldBusinessDate && ChargeUtils.ChargeUtils.exchangeRateNeedUpdate(charges, businessDate)) {
            setTimeout(() => {
              this.$message.success(this.$t('queryJob.BusinessDateChangedUpdateExchangeRate'))
            }, 100)
          }*/
        }
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.copyJobNum = 0

        // 保存业务触发SOP后需要刷新 SOP操作状态弹框
        if (this.sopStateDialog.visible) {
          setTimeout(() => {
            this.sopStateDialog.isNeedRefresh = true
          }, 3000)
        }
        // 保存业务后需要刷新 变更日志记录弹框
        if (this.dataUpdateLogDialog.visible) {
          setTimeout(() => {
            this.dataUpdateLogDialog.isNeedRefresh = true
          }, 3000)
        }
        // 保存成功后触发
        if (Reflect.has(body, 'job')) {
          this.saveResultHandler(body.job)
          // 将rowData放到列表中
          this.$emit('synchronizeRowData', this.rowData)
        }
        JobUtils.handleCreditRemind(this.currentRow, blockCreditData)
      } catch (err) {
        throw err
      } finally {
        if (closingLoading) {
          loading.close()
        }
      }
    },
    async saveSeaBookingSpaceFunc(body) {
      // 数据已被其他人修改
      let dataModified = false
      let userName = ''
      let modifyDate = ''
      let err = null
      try {
        return await saveSeaBookingSpace(body, true, true)
      } catch (res) {
        let error17 = null
        if (res.errors) {
          error17 = res.errors.find(p => p.code === '0017')
        }
        if (error17) {
          dataModified = true
          const start = error17.message.indexOf('[')
          if (start > -1) {
            const end = error17.message.indexOf(']', start)
            if (end > -1) {
              userName = error17.message.substring(start + 1, end)
            }
          }
          const match = error17.message.match(/[0-9]{4}-[0-9]{2}-[0-9]{2} [0-9]{2}:[0-9]{2}:[0-9]{2}/)
          modifyDate = match[0] || ''
          err = res
        } else {
          this.$message({
            showClose: true,
            message: res.errorMsg,
            dangerouslyUseHTMLString: res.errorMsg && res.errorMsg.indexOf('<br/>') > -1,
            type: 'error',
            duration: 5 * 1000
          })
          throw res
        }
      }
      if (dataModified) {
        const oldData = lodash.cloneDeep(this.currentRow) // 旧版本的数据
        const editOldData = lodash.cloneDeep(this.paramsOfTab) // 正在编辑的旧版本的数据
        const pendTabs = [...this.pendTabSet]
        const modifiedData = { ...this.context.modifiedData }
        this.currentRow.version = 0
        for (const key in this.currentRow) {
          if (typeof this.currentRow[key] === 'object') {
            this.currentRow[key] = ''
          }
        }
        this.currentRow.isCompleteRow = false
        await this.onRowClicked({ data: this.currentRow, skipTabHandle: true })
        if (pendTabs.includes('tabTradeDetail')) {
          await new SeaImportJob(this.currentRow).getPoItems()
        }
        if (pendTabs.includes('tabTradeCommission')) {
          await new SeaImportJob(this.currentRow).getPoList()
        }
        if (pendTabs.includes('tabUsCustomsClearance')) {
          await this.$refs['tabUsCustomsClearance'].onShow(this.paramsOfTab, true)
        }
        if (pendTabs.includes('tabUsCustomsClearanceMaster')) {
          await this.$refs['tabUsCustomsClearanceMaster'].onShow(this.paramsOfTab, true)
        }
        const newData = this.currentRow // 最新版本的数据
        this.paramsOfTab = JobUtils.compareAndMergeJobData(oldData, editOldData, newData)
        this.pendTabSet.clear()
        for (const pendTab of pendTabs) {
          this.pendTabSet.add(pendTab)
          this.$refs[pendTab].onShow(this.paramsOfTab, true)
        }
        const filedMap = new Map([['truckingInfo', 'trucking']])
        for (const key in modifiedData) {
          const sourceKey = filedMap.get(key) || key
          if (modifiedData[key] instanceof Array && this.paramsOfTab[sourceKey] instanceof Array) {
            const targetArray = modifiedData[key]
            const souceArray = this.paramsOfTab[sourceKey]
            for (let i = 0; i < targetArray.length; ++i) {
              const sourceItem = souceArray.find(p => p === targetArray[i] || (p.uuid && p.uuid === targetArray[i].uuid))
              if (sourceItem) {
                targetArray[i] = sourceItem
              }
            }
            this.context.modifiedData[key] = modifiedData[key]
          }
        }
        const flag = await this.$confirm(this.$t('queryJob.DataModifiedHasMergeContinueSave', [userName, modifyDate]), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('Message.Yes'),
          cancelButtonText: this.$t('Message.No'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => true).catch(() => false)
        if (flag) {
          const newBody = {}
          if (body.job) {
            newBody.job = { ...this.paramsOfTab }
            // 还原接单分公司
            if (this.useOrderCenterMode) {
              if (newBody.job.cooperate && newBody.job.cooperate.uuid) {
                newBody.job.opOffice = newBody.job.opOffice_original || newBody.job.opOffice // 分公司
                newBody.job.op = newBody.job.op_original || newBody.job.op // 操作
                newBody.job.csr = newBody.job.csr_original || newBody.job.csr // 客服
                newBody.job.overseaOp = newBody.job.overseaOp_original || newBody.job.overseaOp // 海外操作
                newBody.job.dc = newBody.job.dc_original || newBody.job.dc // 单证
                newBody.job.planner = newBody.job.planner_original || newBody.job.planner // 航线负责人
                newBody.job.opDepartment = newBody.job.opDepartment_original || newBody.job.opDepartment // 操作部门
                JobUtils.restoreJobFromCooperateInfo(newBody.job)
              }
            }
            for (const key in newBody.job) {
              if (newBody.job[key] instanceof Object) {
                newBody.job[key] = ''
              }
            }
          }
          for (const key in body) {
            if (key === 'job') {
              continue
            }
            const sourceKey = filedMap.get(key) || key
            if (body[key] instanceof Array) {
              if (this.paramsOfTab[sourceKey] instanceof Array) {
                const uuids = []
                newBody[key] = []
                for (const bodyItem of body[key]) {
                  if (bodyItem.uuid) {
                    uuids.push(bodyItem.uuid)
                  } else {
                    newBody[key].push(bodyItem)
                  }
                }
                for (const mergeItem of this.paramsOfTab[sourceKey]) {
                  if (uuids.includes(mergeItem.uuid)) {
                    newBody[key].push(mergeItem)
                  }
                }
              } else {
                newBody[key] = body[key]
              }
            } else if (body[key] instanceof Object) {
              newBody[key] = this.paramsOfTab[sourceKey] || body[key]
            } else {
              newBody[key] = body[key]
            }
          }
          this.cleanCircleObject(newBody)
          return await saveSeaBookingSpace(newBody, true)
        } else {
          throw err
        }
      }
    },
    // 协作
    cooperationHandler() {
      this.cooperationBranchListDialog.jobUuid = this.paramsOfTab.uuid
      this.cooperationBranchListDialog.job = this.paramsOfTab
      this.cooperationBranchListDialog.orderCenterBranch = this.orderCenterBranch
      this.cooperationBranchListDialog.visible = true
    },
    // 退回
    cooperationReturnHandler() {
      this.$confirm(this.$t('CargoMsg.Cargo_AreYouSureReturn'), this.$t('CargoMsg.Cargo_Tips'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        this.toCooperationReturn()
      }).catch(() => {
        //
      })
    },
    toCooperationReturn() {
      const loading = getLoading4Cxt(this)
      updateState({ jobUuid: this.paramsOfTab.uuid, branchId: this.$store.getters.currentOffice.officeId, statusType: SystemConstants.STATUSTYPE_COOPERATE.code, status: SystemConstants.COOPERATE_STATUS_RETURNED.code }).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_ReturnedSuccess'))
      }).finally(() => {
        loading.close()
      })
    },
    onVerticalScroll(offset) {
      const tabsContent = this.$refs.tabsContainer.querySelector('.el-tabs__content')
      tabsContent.scrollTop = tabsContent.scrollTop + offset
    },
    // im入口值返回
    async getImGroupFunc(paramsOfTab) {
      const result = paramsOfTab.data
      if (!this.imCacheKey || !result || (result && !result.jobNo)) {
        return
      }
      let etdTime = ''
      if (result && result.etd) {
        etdTime = result.etd.slice(0, 10)
      } else {
        etdTime = ''
      }
      const imGroupName = `${result.jobNo}-${etdTime}-${ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', result.dischargingPortCode, 'englishName')}`
      const userInfo = this.$store.getters.userInfo
      // 销售 揽货销售 海外客服 航线负责人 现场操作 单证 自定义岗位1 自定义岗位2
      const personnel = ['sales', 'cargoSalesId', 'overseaOp', 'planner', 'siteOP', 'dc', 'csr', 'userDefinedRoleId1', 'userDefinedRoleId2', 'op']
      const data = {
        tenantId: userInfo.tenantId,
        cargowareCompanyId: result.customerId, // cargoware的合作伙伴，对应b2b的订舱公司
        loginUserId: userInfo.userId,	// 登陆人userId
        customerEmail: result.contactEmail, // 客户邮箱
        otherUserIdList: [userInfo.userId], // 其他内部人userId，userName
        docId: result.jobNo, // 单据Id
        type: '' // 单据type
      }
      if (!data.customerEmail) {
        await this.loadCustomer(data)
      }
      for (const item of personnel) {
        if (result[item]) {
          data.otherUserIdList.push(result[item])
        }
      }
      this.$refs.cargoIm.onShow(data, imGroupName)
    },
    async loadCustomer(data) {
      let company = { cmpIdx: this.job.customerId }
      company = new Company(company)
      const contacts = await company.getContactsBycmpIdx()
      if (contacts) {
        for (const contact of contacts) {
          if (contact.contactPerson === data.customerUserName) {
            data.customerEmail = contact.email
            break
          }
        }
      }
    },
    // 审批发起回调
    applyCloseAndRefresh() {
      this.jobApplyDialog.visible = false
      this.currentRow.version = 0
      this.refresh()
    },
    onCheckConsigneeDefaultChange() {
      LocalStorageUtilsNew.setConfiguration('SI_checkConsigneeDefault', this.sendBranchWindow.checkConsigneeDefault)
      if (this.sendBranchWindow.checkConsigneeDefault) {
        this.onConsigneeTargetChange()
        this.onConsigneeDetailTargetChange()
      } else {
        LocalStorageUtilsNew.removeConfiguration('SI_consigneeTargett')
        LocalStorageUtilsNew.removeConfiguration('SI_consigneeDetailTarget')
      }
    },
    onConsigneeTargetChange() {
      if (this.sendBranchWindow.checkConsigneeDefault) {
        LocalStorageUtilsNew.setConfiguration('SI_consigneeTargett', this.sendBranchWindow.consigneeTarget)
      }
    },
    onConsigneeDetailTargetChange() {
      if (this.sendBranchWindow.checkConsigneeDefault) {
        LocalStorageUtilsNew.setConfiguration('SI_consigneeDetailTarget', this.sendBranchWindow.consigneeDetailTarget)
      }
    },
    toBooking(index) {
      switch (index) {
        case 'API0':
          this.bookingEDIApi('9')
          break
        case 'API1':
          // this.bookingEDIApi('5')
          break
      }
    },
    bookingEDIApi(state) {
      this.apiPopup.title = this.$t('SeaExport.Booking') + ' API'
      this.apiPopup.interfaceArray = this.config.get('BookingEDIApiOpen')
      this.apiPopup.state = state
      this.apiPopup.interfaceType = 1
      this.apiPopup.visible = true
    },
    async selectedApiCallback(row) {
      if (row) {
        const inteface = row['id'].toString()
        if (inteface === '3') { // 吉联新
          const param = {}
          param.jobUuids = [this.job.uuid]
          param.editStatus = parseInt(this.apiPopup.state)
          param.sendType = EdiType.BOOKING_EDI_TYPE.code // 订舱
          param.lob = 'SI'
          const loading = getLoading4Cxt()
          ediApi.getJiLianStarAPI(param).then(result => this.apiSuccess(result, true)).catch(message => {
            this.$message.error(message)
          }).finally(() => {
            loading.close()
          })
        }
      }
    },
    /**
     * 成功
     */
    apiSuccess(event, isJlx = false) {
      const o = event.data
      if (o) {
        const success = o.isSuccess
        if (success) {
          if (o.msg) {
            this.errorLogDialog.errorLog = o.msg
            this.errorLogDialog.visible = true
            return
          }
          this.$message.success(this.$t('SeaExport.RequestSuccessful'))
        } else {
          const text = o.text.toString()
          const textStr = isJlx ? text : text.substring(0, text.length - 5) + text.substring(text.length - 5, text.length).replace(';', '')
          this.errorLogDialog.errorLog = textStr
          this.errorLogDialog.visible = true
        }
      }
    },
    mactchCooperateBranch(cooperateBranch, office) {
      if (cooperateBranch && office) {
        const list = cooperateBranch.split(' | ')
        if (list && list.length > 0) {
          for (const officeName of list) {
            if (officeName === office.chineseName) {
              return true
            }
          }
        }
      }
      return false
    },
    updateJobCooperate(cooperatebranch) {
      this.currentRow.cooperatebranch = cooperatebranch ? cooperatebranch.split(',').join(' | ') : ''
    }
  }
}
</script>

<style scoped lang="scss">
.details-view {
  .btn-group-look.cannot-operate-job::v-deep,
  .tabs-container.cannot-operate-job::v-deep {
    .el-button {
      &.el-button--primary:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #8fbaea;
        border-color: #8fbaea;
      }
      &.el-button--success:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #a1dcc1;
        border-color: #a1dcc1;
      }
      &.el-button--danger:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #fab6b6;
        border-color: #fab6b6;
      }
    }
  }
  .btn-group-look.cannot-operate-job::v-deep {
    .el-dropdown.can-operate {
      .el-button {
        &.el-button--primary {
          pointer-events: auto;
          background-color: #1F75D5;
          border-color: #1F75D5;
          &:focus, &:hover {
            background: #4c91dd;
            border-color: #4c91dd;
          }
        }
      }
    }
  }
}
</style>
